var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganizingProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.11,325.06,86,325.33l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0L99,319.4c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.34,339.17l-13.13.27-6.66.12c-2.22,0-4.46,0-6.69.05h-.45v-.44l0-11.19v-.51h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27V328c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.12-3.7-.13-5.53l.27.27c-4.42.05-8.83.16-13.24.16l-13.24.06.5-.49-.06,11.19-.44-.45c2.18,0,4.36,0,6.54,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.26,203.65l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45l-.06-11.19V192h.5L453,192c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.14,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.27c-4.41.06-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.49,217.76l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l-.05-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.06-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.78,203.65l-13.13.28L417,204c-2.22.05-4.46,0-6.69.06h-.45v-.45l-.05-11.19V192h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.12-3.71-.14-5.54l.28.27c-4.42.06-8.83.16-13.24.17L410.3,193l.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,339.17l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44L665.16,328v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V328c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.19-.45-.45c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.37,65.49l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69.05h-.44v-.45l-.05-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,79.6,679,79.87l-6.66.12c-2.23,0-4.47,0-6.7.05h-.44V79.6l-.06-11.19V67.9h.5L678.9,68c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0L692,73.94c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.11,65.49,86,65.76l-6.66.12c-2.22,0-4.46,0-6.69.05h-.44v-.45L72.13,54.3v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0L99,59.83c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19L72.63,65c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.41,
    y: 93.23,
    width: 59.11,
    height: 38.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.41,
    y: 134.09,
    width: 59.11,
    height: 38.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.26,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.09,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.03,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.98,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.92,
    y: 141.51,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.26,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.09,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.03,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.98,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.92,
    y: 148.5,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.26,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.09,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.03,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.98,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.92,
    y: 155.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.26,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.2,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.15,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 482.09,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.03,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.98,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.92,
    y: 162.49,
    width: 5.75,
    height: 5.75,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.72,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.95,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.17,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473.39,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.62,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.84,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 489.06,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.29,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 499.51,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 504.73,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 509.96,
    y: 129.99,
    width: 2.24,
    height: 5.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.91,97.18a.95.95,0,1,1-1.89,0,.95.95,0,0,1,1.89,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 542.4,
    y: 62.42,
    width: 120.29,
    height: 134.21,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 550.32,
    y: 70.35,
    width: 104.45,
    height: 118.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 559.77,
    y: 91.29,
    width: 36.82,
    height: 43.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.5,94.26a1.33,1.33,0,1,1-1.33-1.33A1.33,1.33,0,0,1,579.5,94.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,100c3.72-.29,7.45-.31,11.17-.35s7.44.06,11.16.35c-3.72.28-7.44.3-11.16.34S570.49,100.31,566.77,100Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,103.47a54.35,54.35,0,0,1,12.14,0,52.81,52.81,0,0,1-12.14,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,106.92c2.59-.27,5.17-.33,7.76-.35s5.17.08,7.75.35c-2.58.27-5.17.33-7.75.35S569.36,107.19,566.77,106.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,110.37c3.24-.27,6.47-.33,9.71-.35s6.47.08,9.7.35c-3.23.27-6.47.33-9.7.34S570,110.64,566.77,110.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,113.82c2.81-.27,5.62-.34,8.43-.35s5.62.07,8.43.35c-2.81.27-5.62.33-8.43.34S569.58,114.09,566.77,113.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,117.26c3.6-.28,7.2-.3,10.79-.34s7.2,0,10.8.34c-3.6.29-7.2.31-10.8.35S570.37,117.55,566.77,117.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,120.71a69.58,69.58,0,0,1,13.94,0,62.57,62.57,0,0,1-7,.35A65.07,65.07,0,0,1,566.77,120.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,124.16c3.72-.29,7.45-.31,11.17-.35s7.44.06,11.16.35c-3.72.29-7.44.3-11.16.34S570.49,124.44,566.77,124.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.77,127.61c3.72-.29,7.45-.31,11.17-.35s7.44.06,11.16.35c-3.72.28-7.44.3-11.16.34S570.49,127.89,566.77,127.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.18,
    y: 118.49,
    width: 43.56,
    height: 51.62,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.29,125.45a1.33,1.33,0,1,1-1.32-1.32A1.32,1.32,0,0,1,625.29,125.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,131.37a30.19,30.19,0,0,1,4.83-.35,29.08,29.08,0,0,1,4.83.35,34.48,34.48,0,0,1-9.66,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,135.26a52.38,52.38,0,0,1,6.25-.35,50.52,50.52,0,0,1,6.26.35,57.71,57.71,0,0,1-12.51,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,139.15a48.15,48.15,0,0,1,11.59,0,48.15,48.15,0,0,1-11.59,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,143a49.56,49.56,0,0,1,11.59,0,43.31,43.31,0,0,1-5.8.35A45,45,0,0,1,608.28,143Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,146.93a37.45,37.45,0,0,1,10.07,0,31.64,31.64,0,0,1-5,.35A32.81,32.81,0,0,1,608.28,146.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,150.83a53.57,53.57,0,0,1,6.44-.35,51.64,51.64,0,0,1,6.45.35,61.26,61.26,0,0,1-12.89,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,154.72a38,38,0,0,1,5.32-.35,36.66,36.66,0,0,1,5.32.35,41.79,41.79,0,0,1-10.64,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,158.61a63.64,63.64,0,0,1,13.33,0,63.64,63.64,0,0,1-13.33,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.28,162.5a65.5,65.5,0,0,1,13.33,0,57.15,57.15,0,0,1-6.66.35A59.49,59.49,0,0,1,608.28,162.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,131.37a51.65,51.65,0,0,1,6.33-.35,49.75,49.75,0,0,1,6.33.35,59.09,59.09,0,0,1-12.66,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,135.26a23.29,23.29,0,0,1,4.16-.35,22.54,22.54,0,0,1,4.16.35,25.62,25.62,0,0,1-8.32,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,139.15a50.84,50.84,0,0,1,11.91,0,50.84,50.84,0,0,1-11.91,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,143a49.56,49.56,0,0,1,11.59,0,43.51,43.51,0,0,1-5.8.35A45,45,0,0,1,627.32,143Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,146.93a59.09,59.09,0,0,1,12.66,0,49.75,49.75,0,0,1-6.33.35A51.65,51.65,0,0,1,627.32,146.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,150.83a32.63,32.63,0,0,1,5-.35,31.43,31.43,0,0,1,5,.35,37.38,37.38,0,0,1-10.06,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,154.72a47.5,47.5,0,0,1,5.95-.35,45.82,45.82,0,0,1,6,.35,52.32,52.32,0,0,1-11.91,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,158.61a30.47,30.47,0,0,1,9.21,0,30.47,30.47,0,0,1-9.21,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.32,162.5a28.84,28.84,0,0,1,8.83,0,25.22,25.22,0,0,1-4.41.35A26.26,26.26,0,0,1,627.32,162.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 593.19,
    y: 79.29,
    width: 22.15,
    height: 22.15,
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.59,81.54a1.32,1.32,0,1,1-1.32-1.32A1.33,1.33,0,0,1,605.59,81.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.68,
    y: 70.35,
    width: 2.99,
    height: 118.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.35 388.33 398.09 388.33 401.74 316.22 218.7 316.22 222.35 388.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76,349.23H316.29l-1.38-25h76.46Zm-72.63-.89h71.8l1.49-23.26H315.85Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.4,378H319.17L318,355.43h71.78ZM320,377.14h67.56l1.3-20.82H319Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,339.43H347.75l-.78-6h13.91Zm-11.57-.89h10.79l.55-4.26H348Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.1,369.75H347.75l-.78-6h13.91Zm-11.57-.89h10.79l.55-4.26H348Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.34,349.23H229.87l-1.38-25H305Zm-72.63-.89h71.8L304,325.08H229.43Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,378H232.75l-1.13-22.6H303.4Zm-68.39-.89h67.56l1.3-20.82H232.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.68,339.43H261.33l-.77-6h13.9Zm-11.57-.89H272.9l.55-4.26H261.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.68,369.75H261.33l-.77-6h13.9Zm-11.57-.89H272.9l.55-4.26H261.56Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.11 388.33 237.01 396.19 234.79 411.97 230.45 411.97 230.45 388.33 238.11 388.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.11 388.33 237.01 396.19 230.45 396.19 230.45 388.33 238.11 388.33",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.33 388.33 383.43 396.19 385.65 411.97 389.99 411.97 389.99 388.33 382.33 388.33",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.33 388.33 383.43 396.19 389.99 396.19 389.99 388.33 382.33 388.33",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 444.65,
    rx: 279.96,
    ry: 20.54,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "51.65 412.48 132.49 412.24 213.32 412.15 375 411.98 536.68 412.15 617.51 412.23 698.35 412.48 617.51 412.72 536.68 412.81 375 412.98 213.32 412.81 132.49 412.72 51.65 412.48",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.38,
    y: 76.83,
    width: 303.31,
    height: 202.09,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.62,
    y: 62.42,
    width: 322.83,
    height: 14.42,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.65,
    y: 76.83,
    width: 1.11,
    height: 98.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.18 180.18 410.24 180.18 411.23 174.51 413.19 174.51 414.18 180.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.65,
    y: 76.83,
    width: 1.11,
    height: 161.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.18 242.86 414.24 242.86 415.23 237.19 417.19 237.19 418.18 242.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.46,
    y: 102.41,
    width: 26.96,
    height: 31.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.91,104.59a1,1,0,1,1-1-1A1,1,0,0,1,280.91,104.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,108.81c2.73-.21,5.45-.22,8.18-.25s5.45,0,8.18.25c-2.73.21-5.45.23-8.18.26S274.32,109,271.59,108.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,111.34a34.94,34.94,0,0,1,4.45-.25,33,33,0,0,1,4.44.25,39.64,39.64,0,0,1-8.89,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,113.86c1.9-.19,3.79-.24,5.68-.25s3.79,0,5.69.25c-1.9.2-3.79.25-5.69.26S273.49,114.06,271.59,113.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,116.39c2.37-.2,4.74-.24,7.11-.25s4.74,0,7.11.25c-2.37.2-4.74.24-7.11.25S274,116.59,271.59,116.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,118.91c2.06-.19,4.12-.24,6.18-.25s4.11.06,6.17.25c-2.06.2-4.11.25-6.17.26S273.65,119.11,271.59,118.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,121.44c2.64-.21,5.27-.22,7.91-.25s5.27,0,7.9.25c-2.63.21-5.27.22-7.9.25S274.23,121.65,271.59,121.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,124a52.25,52.25,0,0,1,10.21,0,50.25,50.25,0,0,1-10.21,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,126.49c2.73-.21,5.45-.22,8.18-.25s5.45,0,8.18.25c-2.73.21-5.45.22-8.18.25S274.32,126.7,271.59,126.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.59,129c2.73-.21,5.45-.22,8.18-.25s5.45,0,8.18.25c-2.73.22-5.45.23-8.18.26S274.32,129.22,271.59,129Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.95,
    y: 225.97,
    width: 26.96,
    height: 31.95,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,228.14a1,1,0,1,1-1.94,0,1,1,0,0,1,1.94,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,232.37c2.73-.21,5.45-.22,8.18-.25s5.45,0,8.18.25c-2.73.21-5.45.22-8.18.25S227.81,232.58,225.08,232.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,234.9a38.13,38.13,0,0,1,8.89,0,39.64,39.64,0,0,1-8.89,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,237.42c1.9-.2,3.79-.24,5.68-.25a56.67,56.67,0,0,1,5.68.25,56.67,56.67,0,0,1-5.68.25C228.87,237.66,227,237.62,225.08,237.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,240c2.37-.2,4.74-.25,7.11-.26s4.74.06,7.11.26c-2.37.19-4.74.24-7.11.25S227.45,240.14,225.08,240Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,242.47c2.06-.2,4.12-.24,6.18-.25s4.11.05,6.17.25c-2.06.2-4.11.25-6.17.25S227.14,242.67,225.08,242.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,245c2.64-.21,5.27-.23,7.91-.26s5.27,0,7.9.26c-2.63.21-5.27.22-7.9.25S227.72,245.21,225.08,245Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,247.52a52.25,52.25,0,0,1,10.21,0,43.54,43.54,0,0,1-5.1.25A46,46,0,0,1,225.08,247.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,250.05c2.73-.21,5.45-.23,8.18-.26s5.45,0,8.18.26c-2.73.21-5.45.22-8.18.25S227.81,250.26,225.08,250.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.08,252.57c2.73-.21,5.45-.22,8.18-.25s5.45,0,8.18.25c-2.73.21-5.45.23-8.18.25S227.81,252.78,225.08,252.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.24,
    y: 126.65,
    width: 31.91,
    height: 37.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.16,131.75a1,1,0,1,1-1-1A1,1,0,0,1,312.16,131.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,136.08a24.23,24.23,0,0,1,7.08,0,25.19,25.19,0,0,1-7.08,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,138.93a37.11,37.11,0,0,1,4.58-.25,35.06,35.06,0,0,1,4.58.25,42.08,42.08,0,0,1-9.16,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,141.78a31.89,31.89,0,0,1,4.25-.25,30.16,30.16,0,0,1,4.24.25,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,144.63a36.17,36.17,0,0,1,8.49,0,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,147.48a27.36,27.36,0,0,1,7.38,0,22.89,22.89,0,0,1-3.69.25A24.09,24.09,0,0,1,299.7,147.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,150.33a44.68,44.68,0,0,1,9.44,0,39.3,39.3,0,0,1-4.72.26A41.48,41.48,0,0,1,299.7,150.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,153.18a30.47,30.47,0,0,1,7.79,0,29.31,29.31,0,0,1-7.79,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,156a44.43,44.43,0,0,1,4.88-.25,42.15,42.15,0,0,1,4.89.25,46,46,0,0,1-9.77,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,158.88a44.43,44.43,0,0,1,4.88-.25,42.15,42.15,0,0,1,4.89.25,46,46,0,0,1-9.77,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,136.08a41.53,41.53,0,0,1,9.28,0,43.18,43.18,0,0,1-9.28,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,138.93a16.59,16.59,0,0,1,3.05-.25,15.7,15.7,0,0,1,3.05.25,18.73,18.73,0,0,1-6.1,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,141.78a33.7,33.7,0,0,1,4.37-.25,32,32,0,0,1,4.36.25,38.23,38.23,0,0,1-8.73,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,144.63a36.17,36.17,0,0,1,8.49,0,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,147.48a43.18,43.18,0,0,1,9.28,0,36.08,36.08,0,0,1-4.64.25A38.08,38.08,0,0,1,313.64,147.48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,150.33a27.36,27.36,0,0,1,7.38,0,24.1,24.1,0,0,1-3.69.26A25.44,25.44,0,0,1,313.64,150.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,153.18a38.23,38.23,0,0,1,8.73,0,36.77,36.77,0,0,1-8.73,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,156a21.36,21.36,0,0,1,3.38-.25,20.12,20.12,0,0,1,3.37.25,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.64,158.88a19.65,19.65,0,0,1,3.24-.25,18.62,18.62,0,0,1,3.24.25,20.32,20.32,0,0,1-6.48,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.49,
    y: 128.39,
    width: 31.91,
    height: 37.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.41,133.49a1,1,0,1,1-1-1A1,1,0,0,1,149.41,133.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,137.83a24.16,24.16,0,0,1,7.07,0,22.19,22.19,0,0,1-3.54.25A23.37,23.37,0,0,1,137,137.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,140.68a40.47,40.47,0,0,1,9.16,0,37,37,0,0,1-4.58.25A38.93,38.93,0,0,1,137,140.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,143.53a34.7,34.7,0,0,1,8.48,0,36.08,36.08,0,0,1-8.48,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,146.38a34.7,34.7,0,0,1,8.48,0,36.08,36.08,0,0,1-8.48,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,149.23a24,24,0,0,1,3.68-.25,22.89,22.89,0,0,1,3.69.25,27.28,27.28,0,0,1-7.37,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,152.08a44.68,44.68,0,0,1,9.44,0,44.68,44.68,0,0,1-9.44,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,154.93a30.47,30.47,0,0,1,7.79,0,30.47,30.47,0,0,1-7.79,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,157.78a47.75,47.75,0,0,1,9.76,0,39.78,39.78,0,0,1-4.88.25A41.87,41.87,0,0,1,137,157.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,160.63a47.75,47.75,0,0,1,9.76,0,45.93,45.93,0,0,1-9.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,137.83a41.44,41.44,0,0,1,9.27,0,37.81,37.81,0,0,1-4.63.25A40,40,0,0,1,150.9,137.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,140.68a18,18,0,0,1,6.1,0,16.59,16.59,0,0,1-3.05.25A17.43,17.43,0,0,1,150.9,140.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,143.53a36.69,36.69,0,0,1,8.72,0,38.14,38.14,0,0,1-8.72,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,146.38a34.78,34.78,0,0,1,8.49,0,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,149.23a37.86,37.86,0,0,1,4.64-.25,35.92,35.92,0,0,1,4.63.25,43.09,43.09,0,0,1-9.27,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,152.08a27.28,27.28,0,0,1,7.37,0,27.28,27.28,0,0,1-7.37,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,154.93a38.14,38.14,0,0,1,8.72,0,38.14,38.14,0,0,1-8.72,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,157.78a22.91,22.91,0,0,1,6.75,0,19.23,19.23,0,0,1-3.38.25A20.12,20.12,0,0,1,150.9,157.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.9,160.63a21.06,21.06,0,0,1,6.47,0,20.26,20.26,0,0,1-6.47,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.67,
    y: 196.32,
    width: 31.91,
    height: 37.81,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.6,201.42a1,1,0,0,1-1.94,0,1,1,0,0,1,1.94,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,205.75a24.23,24.23,0,0,1,7.08,0,25.19,25.19,0,0,1-7.08,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,208.6a37,37,0,0,1,4.58-.25,35.06,35.06,0,0,1,4.58.25,42.08,42.08,0,0,1-9.16,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,211.45a31.74,31.74,0,0,1,4.24-.25,30.3,30.3,0,0,1,4.25.25,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,214.3a36.17,36.17,0,0,1,8.49,0,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,217.15a27.28,27.28,0,0,1,7.37,0,22.76,22.76,0,0,1-3.68.25A24.09,24.09,0,0,1,368.14,217.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,220a44.68,44.68,0,0,1,9.44,0,39.3,39.3,0,0,1-4.72.26A41.48,41.48,0,0,1,368.14,220Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,222.85a30.47,30.47,0,0,1,7.79,0,29.31,29.31,0,0,1-7.79,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,225.7a44.43,44.43,0,0,1,4.88-.25,42.15,42.15,0,0,1,4.89.25,46,46,0,0,1-9.77,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.14,228.55a44.43,44.43,0,0,1,4.88-.25,42.15,42.15,0,0,1,4.89.25,46,46,0,0,1-9.77,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,205.75a41.53,41.53,0,0,1,9.28,0,43.18,43.18,0,0,1-9.28,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,208.6a16.52,16.52,0,0,1,3.05-.25,15.7,15.7,0,0,1,3.05.25,18.73,18.73,0,0,1-6.1,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,211.45a33.65,33.65,0,0,1,4.36-.25,32,32,0,0,1,4.37.25,38.23,38.23,0,0,1-8.73,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,214.3a36.17,36.17,0,0,1,8.49,0,36.17,36.17,0,0,1-8.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,217.15a43.18,43.18,0,0,1,9.28,0,36.17,36.17,0,0,1-4.64.25A38,38,0,0,1,382.08,217.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,220a27.36,27.36,0,0,1,7.38,0,24.1,24.1,0,0,1-3.69.26A25.44,25.44,0,0,1,382.08,220Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,222.85a38.23,38.23,0,0,1,8.73,0,36.77,36.77,0,0,1-8.73,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,225.7a21.36,21.36,0,0,1,3.38-.25,20.12,20.12,0,0,1,3.37.25,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,228.55a19.65,19.65,0,0,1,3.24-.25,18.62,18.62,0,0,1,3.24.25,20.32,20.32,0,0,1-6.48,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.24,261.17h16.05a28.56,28.56,0,0,0,.34-4V241H275.45v16.37C275.45,259,279.24,261.17,279.24,261.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.45,257.36c0,1.59,3.56,3.67,3.78,3.8-.59-.4-.49-3.56-.49-3.56A19.76,19.76,0,0,0,275.45,257.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,245.76c2.38-.2,4.75-.24,7.12-.25s4.75.05,7.12.25c-2.37.2-4.74.24-7.12.25S280.8,246,278.42,245.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,248.42a62.85,62.85,0,0,1,11.2,0,55.09,55.09,0,0,1-5.6.25C282.16,248.66,280.29,248.61,278.42,248.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,251.08c1.87-.19,3.74-.24,5.6-.25a55.09,55.09,0,0,1,5.6.25,55.09,55.09,0,0,1-5.6.25C282.16,251.32,280.29,251.27,278.42,251.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.55,
    y: 225.53,
    width: 20.18,
    height: 20.18,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,230c2.38-.19,4.75-.24,7.12-.25s4.75.06,7.12.25c-2.37.2-4.74.24-7.12.25S145.9,230.15,143.52,230Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,232.61a25.47,25.47,0,0,1,7.12,0,25.47,25.47,0,0,1-7.12,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,235.27c1.87-.19,3.74-.24,5.6-.25s3.74.06,5.61.25a63,63,0,0,1-11.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,237.93c2.38-.19,4.75-.24,7.12-.25s4.75.06,7.12.25c-2.37.2-4.74.24-7.12.25S145.9,238.13,143.52,237.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,240.59c1.83-.19,3.65-.24,5.48-.25s3.65.06,5.48.25a60.19,60.19,0,0,1-11,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.72,
    y: 178.61,
    width: 20.18,
    height: 20.18,
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,183c2.38-.19,4.75-.24,7.12-.25s4.75.06,7.12.25c-2.37.2-4.74.24-7.12.25S139.07,183.23,136.69,183Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,185.69a25.47,25.47,0,0,1,7.12,0,25.47,25.47,0,0,1-7.12,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,188.35c1.87-.19,3.74-.24,5.61-.25s3.73.06,5.6.25a63,63,0,0,1-11.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,191c2.38-.19,4.75-.24,7.12-.25s4.75.06,7.12.25c-2.37.2-4.74.25-7.12.25S139.07,191.21,136.69,191Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.69,193.67c1.83-.19,3.66-.24,5.48-.25s3.65.06,5.48.25a50.24,50.24,0,0,1-5.48.25A53,53,0,0,1,136.69,193.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.82,
    y: 217.84,
    width: 20.18,
    height: 20.18,
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,222.26c2.37-.19,4.74-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.24-7.12.25S340.16,222.46,337.79,222.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,224.92a25.47,25.47,0,0,1,7.12,0,25.47,25.47,0,0,1-7.12,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,227.58c1.87-.19,3.73-.24,5.6-.25s3.73.06,5.6.25a62.85,62.85,0,0,1-11.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,230.24c2.37-.19,4.74-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.25-7.12.25S340.16,230.44,337.79,230.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.79,232.9c1.82-.19,3.65-.24,5.47-.25s3.65.06,5.48.25a50.24,50.24,0,0,1-5.48.25A52.69,52.69,0,0,1,337.79,232.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.08,160.87H325.9a10.77,10.77,0,0,1-1-4V140.69h20.18v16.37A11.38,11.38,0,0,0,346.08,160.87Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.37,145.46c2.37-.19,4.75-.24,7.12-.25s4.74,0,7.12.25c-2.38.2-4.75.24-7.12.25S330.74,145.65,328.37,145.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.37,148.12c2.13-.19,4.27-.24,6.4-.25s4.27,0,6.41.25c-2.14.2-4.27.24-6.41.25S330.5,148.32,328.37,148.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.37,150.78c1.87-.19,3.73-.24,5.6-.25s3.73.06,5.6.25a62.84,62.84,0,0,1-11.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.37,153.44c2.37-.19,4.75-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.24-7.12.25S330.74,153.64,328.37,153.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52,128.88H138.7a10.77,10.77,0,0,0,1-4V108.7H119.52v16.37A11.38,11.38,0,0,1,118.52,128.88Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,113.47c2.37-.19,4.74-.24,7.12-.25s4.74,0,7.12.25c-2.38.2-4.75.24-7.12.25S124.36,113.66,122,113.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,116.13c2.13-.19,4.27-.24,6.4-.25s4.27.05,6.4.25c-2.13.2-4.27.24-6.4.25S124.12,116.33,122,116.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,118.79c1.86-.19,3.73-.24,5.6-.25a55.35,55.35,0,0,1,5.6.25,62.84,62.84,0,0,1-11.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,121.45c2.37-.19,4.74-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.24-7.12.25S124.36,121.65,122,121.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.5,247.53H266.32a10.76,10.76,0,0,1-1-4V227.36H285.5v16.37A11.38,11.38,0,0,0,286.5,247.53Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,232.12c2.37-.19,4.75-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.24-7.12.25S271.16,232.32,268.79,232.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,234.78c2.13-.19,4.27-.24,6.4-.25s4.27.06,6.41.25c-2.14.2-4.27.25-6.41.25S270.92,235,268.79,234.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,237.44c1.87-.19,3.73-.24,5.6-.25s3.73.06,5.6.25a52.46,52.46,0,0,1-5.6.25A55.22,55.22,0,0,1,268.79,237.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.79,240.1c2.37-.19,4.75-.23,7.12-.24s4.74,0,7.12.24c-2.38.2-4.75.25-7.12.25S271.16,240.3,268.79,240.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.38,132.84H209.2a10.77,10.77,0,0,1-1-4V112.66h20.18V129A11.38,11.38,0,0,0,229.38,132.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,117.43c2.37-.2,4.74-.24,7.12-.25s4.74,0,7.11.25c-2.37.19-4.74.24-7.11.25S214,117.62,211.67,117.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,120.09c2.13-.2,4.27-.24,6.4-.25s4.27,0,6.4.25c-2.13.2-4.27.24-6.4.25S213.8,120.28,211.67,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,122.75c1.86-.19,3.73-.24,5.6-.25a55.35,55.35,0,0,1,5.6.25,55.35,55.35,0,0,1-5.6.25C215.4,123,213.53,122.94,211.67,122.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,125.41c2.37-.19,4.74-.24,7.12-.25s4.74,0,7.11.25c-2.37.2-4.74.24-7.11.25S214,125.6,211.67,125.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,225.08H321.82a10.76,10.76,0,0,1-1-4V204.91H341v16.37A11.38,11.38,0,0,0,342,225.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,209.67c2.37-.19,4.74-.24,7.12-.25s4.74.06,7.12.25c-2.38.2-4.75.24-7.12.25S326.66,209.87,324.29,209.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,212.33c2.13-.19,4.27-.24,6.4-.25s4.27.06,6.4.25c-2.13.2-4.27.25-6.4.25S326.42,212.53,324.29,212.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,215c1.86-.19,3.73-.24,5.6-.25s3.73.06,5.6.25a52.46,52.46,0,0,1-5.6.25A55.09,55.09,0,0,1,324.29,215Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,217.65c2.37-.19,4.74-.23,7.12-.24s4.74.05,7.12.24c-2.38.2-4.75.25-7.12.25S326.66,217.85,324.29,217.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,166.81h-16a27.76,27.76,0,0,1-.35-4V146.63h20.18V163C391.14,164.64,387.35,166.81,387.35,166.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,163c0,1.59-3.56,3.67-3.78,3.8.59-.4.49-3.56.49-3.56A19.76,19.76,0,0,1,391.14,163Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,151.4c2.38-.19,4.75-.24,7.12-.25s4.75,0,7.12.25c-2.37.2-4.74.24-7.12.25S376.31,151.6,373.93,151.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,154.06c1.87-.19,3.74-.24,5.6-.25s3.74.06,5.61.25a63,63,0,0,1-11.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.93,156.72c1.87-.19,3.74-.24,5.6-.25s3.74.06,5.61.25a63,63,0,0,1-11.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,186.18h-16a27.72,27.72,0,0,1-.35-4V166h20.18v16.38C138.67,184,134.88,186.18,134.88,186.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.67,182.37c0,1.59-3.56,3.67-3.78,3.8.59-.4.49-3.56.49-3.56A19.76,19.76,0,0,1,138.67,182.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,170.77c2.37-.19,4.75-.24,7.12-.25s4.75.06,7.12.25c-2.37.2-4.75.24-7.12.25S123.83,171,121.46,170.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,173.43c1.87-.19,3.73-.24,5.6-.25s3.74.06,5.6.25a62.84,62.84,0,0,1-11.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.46,176.09c1.87-.19,3.73-.24,5.6-.25s3.74.06,5.6.25a62.84,62.84,0,0,1-11.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.86,145.1h-16a27.76,27.76,0,0,1-.35-4V124.92h20.18v16.37C244.65,142.93,240.86,145.1,240.86,145.1Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,141.29c0,1.59-3.56,3.67-3.78,3.8.59-.4.49-3.56.49-3.56A19.76,19.76,0,0,1,244.65,141.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44,129.69c2.38-.19,4.75-.24,7.12-.25s4.75.05,7.12.25c-2.37.2-4.74.24-7.12.25S229.82,129.88,227.44,129.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44,132.35c1.87-.19,3.74-.24,5.6-.25a55.41,55.41,0,0,1,5.61.25,55.41,55.41,0,0,1-5.61.25C231.18,132.59,229.31,132.54,227.44,132.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.44,135c1.87-.19,3.74-.24,5.6-.25a55.41,55.41,0,0,1,5.61.25,63,63,0,0,1-11.21,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.04 89.61 257.28 111.68 257.42 133.75 257.54 177.88 257.42 222.01 257.28 244.07 257.04 266.14 256.79 244.07 256.65 222.01 256.54 177.88 256.65 133.75 256.79 111.68 257.04 89.61",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,202a20,20,0,0,1,6-7.31,14.47,14.47,0,0,1,4.27-2.17,15.62,15.62,0,0,1,4.76-.63,11.46,11.46,0,0,1,8.62,3.89,8.18,8.18,0,0,1,1.27,2.13,4.9,4.9,0,0,1,.34,2.53,2.88,2.88,0,0,1-4.24,2.14,3.9,3.9,0,0,1-1.49-2.19,8.19,8.19,0,0,1-.32-2.49,12.32,12.32,0,0,1,1.09-4.79,14.11,14.11,0,0,1,6.69-6.94,14,14,0,0,1,9.49-1.26,16.45,16.45,0,0,1,8.11,4.92l-.14.13a17,17,0,0,0-8.12-4.31,13.18,13.18,0,0,0-4.56,0,14.34,14.34,0,0,0-4.29,1.51,13.73,13.73,0,0,0-6.18,6.44,11.59,11.59,0,0,0-1.06,4.36,7,7,0,0,0,.23,2.19,2.94,2.94,0,0,0,1.05,1.68,1.8,1.8,0,0,0,1.81,0,1.94,1.94,0,0,0,1.1-1.52,5.47,5.47,0,0,0-1.38-4,10.77,10.77,0,0,0-8-3.76,15.79,15.79,0,0,0-4.59.51,14.15,14.15,0,0,0-4.19,2A19.8,19.8,0,0,0,327.3,202Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.51 189.64 371.35 189.65 371 184.83 372.4 190.63 366.51 189.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.06,138.21a49.32,49.32,0,0,0-.94,13.49,35.7,35.7,0,0,0,3.19,13,26.45,26.45,0,0,0,3.56,5.64,30.35,30.35,0,0,0,10.52,8.06c1,.54,2.05.91,3.09,1.35s2.13.74,3.2,1.12l-.06.24a31.8,31.8,0,0,1-12.6-5.29,26.22,26.22,0,0,1-8.49-10.76,36.41,36.41,0,0,1-2.94-13.34A49,49,0,0,1,278,138.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.51 183.32 300.26 180.85 297.44 176.3 301.8 181.27 295.51 183.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.31,212.36a49,49,0,0,1-3.57,13,35.47,35.47,0,0,1-7.31,11.23,26.4,26.4,0,0,1-5.22,4.15,30.85,30.85,0,0,1-6.05,2.76,38,38,0,0,1-9.9,1.62c-1.13,0-2.26,0-3.39,0l0,.25a31.86,31.86,0,0,0,13.65-.83,26.34,26.34,0,0,0,11.56-7.35,36.27,36.27,0,0,0,7.18-11.62,49.25,49.25,0,0,0,3.19-13.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.94 249.18 168.27 245.27 172.44 241.91 166.68 245.16 171.94 249.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,113.43c2-.15,3.95-.23,5.93-.29s3.95-.07,5.92-.08,3.95,0,5.92.08,4,.14,5.93.29c-2,.16-3.95.23-5.93.29s-3.94.08-5.92.09-3.95,0-5.92-.09S347.49,113.59,345.51,113.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,116.26a55.71,55.71,0,0,1,12.82,0,54.25,54.25,0,0,1-12.82,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,119.09c1.75-.15,3.5-.22,5.24-.28s3.5-.08,5.24-.09,3.5,0,5.25.09,3.49.13,5.24.28c-1.75.16-3.5.23-5.24.29s-3.5.08-5.25.09-3.49,0-5.24-.09S347.26,119.25,345.51,119.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,121.93c1.42-.16,2.85-.23,4.27-.29s2.84-.08,4.26-.09,2.84,0,4.27.09,2.84.13,4.26.29c-1.42.15-2.84.22-4.26.28s-2.85.08-4.27.09-2.84,0-4.26-.09S346.93,122.08,345.51,121.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,207.6c2-.15,3.95-.23,5.93-.29s3.95-.08,5.92-.08,3.95,0,5.93.08,4,.13,5.92.29c-2,.16-3.95.23-5.92.29s-3.95.08-5.93.08-4,0-5.92-.08S279,207.75,277,207.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,210.43c1.53-.15,3.05-.23,4.58-.29s3.05-.07,4.57-.08,3.05,0,4.58.08,3,.14,4.57.29c-1.52.16-3.05.23-4.57.29s-3.05.08-4.58.09-3,0-4.57-.09S278.53,210.59,277,210.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,213.26c1.75-.15,3.5-.22,5.25-.28s3.49-.08,5.24-.09,3.49,0,5.24.08,3.49.14,5.24.29c-1.75.16-3.49.23-5.24.29s-3.5.08-5.24.09-3.5,0-5.24-.09S278.75,213.42,277,213.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.55,
    y: 170.03,
    width: 3.31,
    height: 16.83,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.24,
    y: 172.83,
    width: 3.31,
    height: 14.03,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.93,
    y: 177.93,
    width: 3.31,
    height: 8.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.63,
    y: 172.59,
    width: 3.31,
    height: 14.28,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.32,
    y: 174.93,
    width: 3.31,
    height: 11.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.01,
    y: 167.69,
    width: 3.31,
    height: 19.17,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,166.52l0,5.09,0,5.08,0,10.17-.08-.08c8,0,16.09,0,24.13,0h6.71l5.95.05-5.95,0-6.71,0c-8,0-16.09,0-24.13,0h-.08v-.09l0-10.17,0-5.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,167.69a2.71,2.71,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,169.71a2.71,2.71,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,171.73a2.71,2.71,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,173.74a3,3,0,0,1,1.46,0,2.3,2.3,0,0,1-.73.1A2.62,2.62,0,0,1,304.9,173.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,175.76a3,3,0,0,1,1.46,0,2.71,2.71,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,177.78a3,3,0,0,1,1.46,0,2.71,2.71,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,179.8a3,3,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,181.82a3,3,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.9,183.84a2.71,2.71,0,0,1,1.46,0,3,3,0,0,1-1.46,0Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.61,173.37V191l-11.44,13.41a17.63,17.63,0,0,1,11.44-31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,192.8a17.63,17.63,0,0,1-29.08,13.41L207.2,192.8V175.16a17.63,17.63,0,0,1,17.64,17.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.84,192.8a17.63,17.63,0,0,1-29.08,13.41L207.2,192.8V175.16a17.63,17.63,0,0,1,17.64,17.64Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.51,
    y: 159.66,
    width: 0.5,
    height: 22.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.76,159.91a1.85,1.85,0,1,1,1.84-1.85A1.85,1.85,0,0,1,195.76,159.91Zm0-3.19a1.35,1.35,0,1,0,1.34,1.34A1.34,1.34,0,0,0,195.76,156.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.59,
    y: 156.47,
    width: 17.67,
    height: 0.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.59,
    y: 158.06,
    width: 10,
    height: 0.8,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07,94.27h-1.91v6.41a.66.66,0,0,1-1.32,0V94.27H163a.66.66,0,0,1-.66-.67.65.65,0,0,1,.66-.66h5.12a.66.66,0,0,1,.66.66A.67.67,0,0,1,168.07,94.27Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67,94a4.41,4.41,0,0,1,0,6.07,3.92,3.92,0,0,1-2.87,1.28,4,4,0,0,1-2.93-1.28,4.47,4.47,0,0,1,0-6.07,4,4,0,0,1,2.93-1.29A3.9,3.9,0,0,1,176.67,94Zm-.16,3a3.13,3.13,0,0,0-.81-2.1,2.59,2.59,0,0,0-3.84,0,3.08,3.08,0,0,0-.81,2.1,3,3,0,0,0,.81,2.09,2.57,2.57,0,0,0,3.84,0A3.07,3.07,0,0,0,176.51,97Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.85,100.68V93.6a.65.65,0,0,1,.66-.66h1.41a4.2,4.2,0,0,1,0,8.4h-1.41A.66.66,0,0,1,183.85,100.68Zm1.33-.67h.74a2.87,2.87,0,0,0,0-5.74h-.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.92,94a4.41,4.41,0,0,1,0,6.07,3.94,3.94,0,0,1-2.87,1.28,4.06,4.06,0,0,1-2.94-1.28,4.49,4.49,0,0,1,0-6.07,4,4,0,0,1,2.94-1.29A3.91,3.91,0,0,1,198.92,94Zm-.16,3a3.13,3.13,0,0,0-.81-2.1,2.59,2.59,0,0,0-3.84,0,3.09,3.09,0,0,0-.82,2.1,3,3,0,0,0,.82,2.09,2.57,2.57,0,0,0,3.84,0A3.07,3.07,0,0,0,198.76,97Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.84,100.68V93.6a.65.65,0,0,1,.66-.66h1.41a4.2,4.2,0,0,1,0,8.4H317.5A.66.66,0,0,1,316.84,100.68Zm1.33-.67h.74a2.87,2.87,0,0,0,0-5.74h-.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.91,94a4.41,4.41,0,0,1,0,6.07,3.94,3.94,0,0,1-2.87,1.28,4,4,0,0,1-2.94-1.28,4.49,4.49,0,0,1,0-6.07A4,4,0,0,1,329,92.7,3.91,3.91,0,0,1,331.91,94Zm-.16,3a3.13,3.13,0,0,0-.81-2.1,2.59,2.59,0,0,0-3.84,0,3,3,0,0,0-.82,2.1,3,3,0,0,0,.82,2.09,2.57,2.57,0,0,0,3.84,0A3.07,3.07,0,0,0,331.75,97Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.49,100.68a.65.65,0,1,1-1.3,0v-7h0a.65.65,0,0,1,1.17-.41l3.88,5.36V93.71a.65.65,0,0,1,.64-.65.66.66,0,0,1,.66.65v7a.65.65,0,0,1-1.15.42l-.06-.07-3.84-5.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.65,100.68V93.6a.65.65,0,0,1,.66-.66h3.92a.67.67,0,0,1,0,1.33H345v2.2h2.79a.67.67,0,0,1,0,1.33H345V100h3.25a.67.67,0,0,1,0,1.33h-3.89s0,0,0,0h0A.66.66,0,0,1,343.65,100.68Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.14,268.15s-20.25-2.84-15.52-27.29C73.62,240.86,96.25,245.94,89.14,268.15Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.14,268.15s-20.25-2.84-15.52-27.29C73.62,240.86,96.25,245.94,89.14,268.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,263c-.4-1.23-.86-2.45-1.38-3.64,0-.16,0-.31,0-.46l-.09-1c0-.73-.1-1.46-.14-2.19-.09-1.46-.18-2.93-.2-4.39a.07.07,0,0,0-.13,0c0,1.47,0,2.93,0,4.39,0,.73.08,1.46.12,2.19,0,.17,0,.33,0,.49a42.56,42.56,0,0,0-4.06-6.94A35.58,35.58,0,0,0,80,248.67c-.8-.93-1.66-1.81-2.47-2.72a.06.06,0,0,0-.09.09,35.91,35.91,0,0,1,3.9,5.19c.62.93,1.2,1.89,1.75,2.86l-.18-.08-.73-.29-1.65-.62c-1.09-.41-2.18-.8-3.26-1.22-.06,0-.11.09,0,.12,1.07.43,2.14.88,3.2,1.34L82,254l.79.32a2.67,2.67,0,0,0,.54.19c.41.73.81,1.47,1.19,2.22A53.49,53.49,0,0,1,87,262.59l.15.42a11.48,11.48,0,0,0-1.66-.8l-2.1-1c-1.42-.65-2.83-1.31-4.19-2.08-.07,0-.13.07-.06.11,1.39.76,2.75,1.57,4.15,2.32.69.38,1.4.75,2.11,1.09a6.54,6.54,0,0,0,1.9.77,23.59,23.59,0,0,1,1.33,5.74c.23,2.77.2,5.55.26,8.32a0,0,0,0,0,.08,0c.2-2.51.31-5,.32-7.57A21.72,21.72,0,0,0,88.12,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,248.66a24,24,0,0,0-.2,4.32s.06,0,.06,0c.08-1.43.1-2.85.26-4.28C85.13,248.62,85,248.58,85,248.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.21,249.89a15.78,15.78,0,0,1-2.61-1.28c-.06-.05-.12.06,0,.11A9.78,9.78,0,0,0,79.18,250S79.26,249.91,79.21,249.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,307c0-2.23-.06-4.47-.08-6.71,0-7.43-.11-14.87-.24-22.3q-.16-8.85-.41-17.7a.09.09,0,0,0-.06-.07c0-1.62,0-3.23,0-4.84,0,0,0-.06-.1-.06s-.09,0-.09.06l0,4.85a.08.08,0,0,0-.05.07c-.3,10.5-.56,21-.63,31.51,0,2.13,0,4.27,0,6.4Q88,308.44,88,318.72c0,1.09,0,2.18,0,3.27,0,6.26.07,12.53.07,18.8,0,.33.37.5.77.52s.94-.17.94-.55c0-6.91.05-13.82.05-20.73C89.81,315.67,89.82,311.32,89.79,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.33,300.16s-9.74-7.21-19-2.34S51.65,321.5,51.65,321.5s13.57,1.94,22.12-6.19C82,307.46,81.33,300.16,81.33,300.16Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,300.61a11.79,11.79,0,0,0-5.65-.74,9.4,9.4,0,0,0-1.19-.11l-1.37-.11-2.84-.2c-1.93-.14-3.85-.26-5.77-.45-.07,0-.08.11,0,.12,1.89.24,3.78.51,5.69.71,1,.09,2,.2,2.94.27.23,0,.47,0,.71.07-.29.06-.58.13-.86.21a23.13,23.13,0,0,0-4.42,1.79c-.77.14-1.53.36-2.28.53-1.21.29-2.41.6-3.61.91-2.36.62-4.7,1.32-7,2-.08,0,0,.14,0,.12,2.34-.57,4.7-1.1,7.05-1.66l3.43-.82.89-.21a28.74,28.74,0,0,0-6.92,6A37.59,37.59,0,0,0,58,316.65c0,.07.06.14.1.07a36.75,36.75,0,0,1,5.82-7.65l-.12.39c-.19.58-.37,1.15-.55,1.72-.36,1.15-.72,2.3-1.06,3.45,0,.08.09.1.12,0,.41-1.11.8-2.23,1.19-3.35.19-.55.38-1.1.58-1.64l.29-.86.09-.26a35.72,35.72,0,0,1,3.46-2.95,26.22,26.22,0,0,1,5.17-3c0,.17-.06.34-.1.5-.1.44-.19.89-.29,1.33-.19.92-.37,1.85-.55,2.77-.36,1.89-.59,3.8-.94,5.68a.06.06,0,0,0,.12,0c.43-1.89,1-3.76,1.42-5.66.21-1,.43-1.9.62-2.85l.27-1.34c.05-.25.11-.5.14-.74.18-.08.35-.16.53-.22a15.24,15.24,0,0,1,8.1-1.11,8,8,0,0,1,5.87,4.7c.09.21.42.07.37-.14A7.53,7.53,0,0,0,84,300.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.07,308.64c-.27,1.23-.55,2.47-.82,3.7a27.83,27.83,0,0,0-.68,3.6,0,0,0,0,0,.08,0,27.69,27.69,0,0,0,.83-3.63c.24-1.21.48-2.43.71-3.65A.06.06,0,0,0,69.07,308.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.65,311.78c-1.24.63-2.44,1.34-3.74,1.86a.06.06,0,1,0,.05.11,37.44,37.44,0,0,0,3.72-1.93A0,0,0,1,0,59.65,311.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,286.91s-11.9.76-17.44-7.09-4.3-19.07-4.3-19.07,12.51,1.52,17.47,7.16S83.52,286.91,83.52,286.91Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.11,298.66c-.41-1.28-.92-2.54-1.4-3.79s-1-2.39-1.49-3.56a75.74,75.74,0,0,0-3.56-7c-.84-1.45-1.74-2.85-2.67-4.23,0-.22-.06-.43-.09-.64-.06-.37-.11-.74-.17-1.1-.12-.76-.25-1.51-.38-2.26-.27-1.65-.61-3.28-.87-4.93,0-.07-.14-.07-.13,0,.25,1.62.41,3.26.64,4.88.11.8.21,1.6.33,2.4.05.29.09.57.14.86a86.74,86.74,0,0,0-5.89-7.64l-.87-1c0-.09-.07-.18-.11-.27s-.18-.46-.26-.68c-.17-.48-.35-1-.52-1.42-.33-.94-.63-1.88-.88-2.84,0-.07-.14,0-.12,0,.24,1,.49,1.95.78,2.92q.21.69.45,1.38l.09.23c-1.52-1.66-3.11-3.26-4.71-4.84-.06-.05-.14,0-.09.09a86.34,86.34,0,0,1,8.44,10.34,7.07,7.07,0,0,0-.88-.22c-.92-.18-1.84-.31-2.77-.43-1.94-.25-3.87-.49-5.81-.8-.07,0-.11.11,0,.12,1.85.37,3.68.78,5.51,1.2.86.2,1.73.37,2.6.54a16.18,16.18,0,0,1,2.09.6c.19.27.39.54.58.82.88,1.27,1.72,2.57,2.54,3.88l-1.22-.24c-.92-.18-1.84-.34-2.76-.5-1.82-.29-3.64-.61-5.43-1a.06.06,0,1,0,0,.12c1.82.43,3.62.93,5.43,1.41.87.23,1.75.44,2.63.64l1.32.28a3.89,3.89,0,0,0,.54.1q2.61,4.23,4.88,8.65c.67,1.3,1.31,2.6,1.93,3.92s1.18,2.73,1.76,4.11C88.77,299.07,89.21,299,89.11,298.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.92,271.29c-.22-1.13-.46-2.27-.72-3.4,0-.08-.13,0-.11,0,.22,1.11.44,2.23.64,3.35a31.88,31.88,0,0,0,.68,3.34s0,0,0,0A23.39,23.39,0,0,0,76.92,271.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,271c-.55-.27-1.14-.5-1.71-.72l-.91-.35-.46-.19a1.86,1.86,0,0,1-.5-.22c-.09-.07-.15.09-.06.11a1.89,1.89,0,0,1,.51.21l.45.2.87.38a16.52,16.52,0,0,0,1.76.7C70,271.1,70,271,70,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.71,277.55s7.21-13.46,18.17-15.55,17.67,9.2,17.67,9.2-8,10.21-18.06,12S95.71,277.55,95.71,277.55Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,268a29.52,29.52,0,0,0-8.6.11l.49-.27,2.43-1.25a57,57,0,0,1,5.15-2.51.06.06,0,1,0,0-.11c-1.72.79-3.5,1.46-5.22,2.25-.86.4-1.7.81-2.54,1.26a18.09,18.09,0,0,0-1.67.9,30.34,30.34,0,0,0-7,2.31c.46-.5.92-1,1.37-1.49,1-1.12,2-2.29,3.15-3.31.06-.06,0-.14-.09-.09-1.15,1-2.36,2-3.47,3.09-.54.53-1.06,1.07-1.56,1.63-.25.28-.5.57-.74.87a28.88,28.88,0,0,0-14.7,19.85c0,.07.1.11.12,0a33.05,33.05,0,0,1,8.06-13.64,31.65,31.65,0,0,1,14.68-8.5,32.06,32.06,0,0,1,10.14-.92C121.35,268.26,121.36,268.05,121.23,268Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,271.2s-8,10.21-18.06,12c-7.67,1.36-14-2.64-16.55-4.61l-.55-.91s5.19-4.38,15-6.9S131.55,271.2,131.55,271.2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,263.24a27.66,27.66,0,0,0-2.44,1.6,15.51,15.51,0,0,0-2.11,1.94c-.06.06,0,.14.09.09.73-.64,1.46-1.27,2.22-1.87a23.1,23.1,0,0,1,2.3-1.66C115,263.3,114.93,263.19,114.86,263.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.88,265.51c-.41.17-.83.32-1.23.49l-1.22.5c-.09,0-.05.18,0,.15l1.22-.5,1.22-.52C121,265.6,121,265.48,120.88,265.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.27,294.49s1.93,13.35,12,18,22.28,0,22.28,0S123.71,283.62,94.27,294.49Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,303.82c-.92-.1-1.85-.26-2.76-.43l-1.35-.25-.71-.14c-.27-.26-.53-.51-.81-.76a40.7,40.7,0,0,0-6.14-4.45,36.48,36.48,0,0,0-3.68-1.89h.19l3.3.14c2.21.11,4.41.15,6.61.3.08,0,.08-.12,0-.13-2.21-.15-4.41-.39-6.62-.58l-3.21-.29-1.65-.14-.43,0c-.57-.22-1.15-.42-1.73-.6a15.67,15.67,0,0,0-8.5-.47c-2.53.65-5,2.3-5.7,5,0,.1.12.16.16.07.94-2.23,3.41-3.35,5.64-3.81a13.57,13.57,0,0,1,4.54-.09,11.28,11.28,0,0,0,.51,2c.28.94.55,1.88.84,2.82.57,1.87,1.19,3.73,1.75,5.61,0,.08.14,0,.12,0-.47-1.87-.86-3.76-1.32-5.64-.22-.92-.45-1.84-.68-2.76a15.71,15.71,0,0,0-.5-1.9,25.18,25.18,0,0,1,2.6.61,39.38,39.38,0,0,1,4.55,1.67c.15.95.36,1.9.58,2.84.28,1.17.58,2.34,1,3.49a.06.06,0,0,0,.12,0c0-.07,0-.15,0-.22h0c-.22-1.09-.47-2.18-.7-3.27-.18-.88-.35-1.77-.54-2.64,1.24.56,2.47,1.17,3.66,1.85,0,.27.09.55.13.8.07.46.15.91.24,1.37.19,1,.39,2.06.64,3.07a49,49,0,0,0,1.72,5.81.08.08,0,0,0,0,.08l.06.06c0,.06.12,0,.1-.06-.46-2-1-3.94-1.43-5.92-.21-1-.43-2-.63-3-.1-.5-.19-1-.29-1.5,0-.14,0-.29-.07-.44a40.19,40.19,0,0,1,3.91,2.6,42,42,0,0,1,6,5.47c.07.08.21,0,.15-.12a37.21,37.21,0,0,0-2.4-2.92c-.5-.54-1-1.07-1.56-1.58l.17,0,1.41.21c.93.13,1.86.22,2.79.32C121.65,304,121.68,303.83,121.6,303.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.54,308.35h0c0-.12,0-.23-.05-.35s-.1-.28-.12-.43h0c-.2-.89-.38-1.79-.54-2.69,0-.06-.11,0-.11,0a10.71,10.71,0,0,0,.77,3.48,0,0,0,0,0,.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.14,308.14a.06.06,0,0,0-.06-.06c-.28-1.18-.55-2.36-.8-3.56-.12-.62-.25-1.25-.37-1.87-.07-.34-.13-.68-.19-1a2.93,2.93,0,0,0-.22-.87.06.06,0,0,0-.11,0,6.09,6.09,0,0,0,.25,1.79c.12.65.25,1.31.39,1.95.3,1.32.63,2.63,1,3.93,0,.07.14.06.13,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.69,300c-1.84-.25-3.67-.52-5.51-.74-.08,0-.11.11,0,.12,1.83.27,3.67.5,5.51.74C120.73,300.11,120.76,300,120.69,300Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.13,263.17S83,236.22,112,225.31C112,225.31,120,260.79,89.13,263.17Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.38,247.88l.31-.19,1.64-.91,3.36-1.88c2.21-1.24,4.39-2.52,6.61-3.73.07,0,0-.14-.06-.11-2.23,1.22-4.5,2.35-6.74,3.54l-3.32,1.75-1.36.72c1-1.83,2-3.63,3.13-5.36,1.52-2.31,3.18-4.51,4.9-6.66.08-.1,0-.23-.14-.14a46.41,46.41,0,0,0-6.7,8.21,2.62,2.62,0,0,0,0-.28c0-.67,0-1.34.06-2,0-1.32,0-2.63,0-4,0-.08-.12-.07-.13,0,0,1.29-.21,2.58-.28,3.87,0,.65-.06,1.3-.08,1.94,0,.35,0,.75,0,1.13-.6.95-1.17,1.92-1.71,2.89a49.19,49.19,0,0,0-2.59,5.43c0-.67-.07-1.34-.11-2-.09-1.48-.27-2.95-.33-4.43,0-.07-.13-.07-.12,0,0,1.47,0,2.95,0,4.43,0,.74,0,1.47.1,2.21,0,.27,0,.55,0,.82a49.06,49.06,0,0,0-2.19,7.41c-.56,2.7-.79,5.4-1.08,8.14a0,0,0,0,0,0,0,45.09,45.09,0,0,1,1.54-7.26c.36-1.27.74-2.54,1.14-3.79,1.21-.57,2.36-1.28,3.53-1.92s2.42-1.33,3.63-2c2.42-1.33,4.83-2.68,7.32-3.85.08,0,0-.13-.06-.1-2.53,1.14-5.07,2.23-7.55,3.48-1.24.62-2.45,1.28-3.65,2-1,.56-2,1.13-3,1.78.28-.84.57-1.67.89-2.5A72,72,0,0,1,95.38,247.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.94,241.72c0-.08-.13-.08-.13,0,.11,1.54.16,3.08.32,4.61a.07.07,0,0,0,.14,0C93.22,244.79,93.05,243.26,92.94,241.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.82,246.87c-1.81.73-3.64,1.42-5.44,2.18,0,0,0,.1,0,.08,1.83-.69,3.64-1.43,5.46-2.14C106.93,247,106.9,246.84,106.82,246.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.58,234.44a46.21,46.21,0,0,0-5.15,2.76c-.09.05,0,.18.08.13,1.68-1,3.39-1.92,5.13-2.79C109.71,234.51,109.65,234.4,109.58,234.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.37,
    y: 321.46,
    width: 41.77,
    height: 44.02,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.5,
    y: 337.04,
    width: 2.14,
    height: 75.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.65,
    y: 337.04,
    width: 2.14,
    height: 75.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.21,
    y: 337.04,
    width: 2.14,
    height: 75.41,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.57,
    y: 362.66,
    width: 45.15,
    height: 6.1,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.39,
    y: 379.53,
    width: 21.34,
    height: 3.75,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.3 434.43 371 434.43 352.2 346.69 351.13 341.69 347.75 325.94 346.5 320.06 341.77 298.02 340.12 290.31 348.33 290.31 349.66 298.02 350.54 303.09 351.13 306.46 354.5 325.94 355.58 332.2 373.3 434.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.33 290.31 349.66 298.02 341.77 298.02 340.12 290.31 348.33 290.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.58 332.2 352.2 346.69 351.13 341.69 347.75 325.94 346.5 320.06 350.54 303.09 351.13 306.46 354.5 325.94 355.58 332.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.13 290.31 360.48 298.02 354.5 325.94 351.13 341.69 331.25 434.43 328.96 434.43 347.75 325.94 351.13 306.46 352.59 298.02 353.93 290.31 362.13 290.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.13 290.31 360.48 298.02 352.59 298.02 353.93 290.31 362.13 290.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 557.95,
    y: 379.53,
    width: 21.34,
    height: 3.75,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.86 434.43 588.56 434.43 569.76 346.69 568.69 341.69 565.31 325.94 564.06 320.06 559.33 298.02 557.68 290.31 565.89 290.31 567.22 298.02 568.1 303.09 568.69 306.46 572.06 325.94 573.14 332.2 590.86 434.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "565.89 290.31 567.22 298.02 559.33 298.02 557.68 290.31 565.89 290.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.14 332.2 569.76 346.69 568.69 341.69 565.31 325.94 564.06 320.06 568.1 303.09 568.69 306.46 572.06 325.94 573.14 332.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.69 290.31 578.04 298.02 572.06 325.94 568.69 341.69 548.82 434.43 546.52 434.43 565.31 325.94 568.69 306.46 570.15 298.02 571.49 290.31 579.69 290.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.69 290.31 578.04 298.02 570.15 298.02 571.49 290.31 579.69 290.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.78,
    y: 279.75,
    width: 284.26,
    height: 10.56,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "528.38 279.75 475.4 279.75 471.3 243.76 524.28 243.76 528.38 279.75",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525.5 277.33 477.73 277.33 474.18 246.17 521.95 246.17 525.5 277.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.77,
    y: 277.33,
    width: 68.16,
    height: 2.41,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.57,
    y: 277.33,
    width: 68.16,
    height: 2.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.12 247.69 521.95 246.17 474.18 246.17 474.36 247.69 522.12 247.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.2,246.93a.42.42,0,0,0,.38.38.32.32,0,0,0,.3-.38.41.41,0,0,0-.38-.38A.32.32,0,0,0,478.2,246.93Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.82,246.93a.41.41,0,0,0,.38.38.32.32,0,0,0,.3-.38.42.42,0,0,0-.38-.38A.32.32,0,0,0,476.82,246.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.44,246.93a.41.41,0,0,0,.38.38.32.32,0,0,0,.3-.38.42.42,0,0,0-.38-.38A.32.32,0,0,0,475.44,246.93Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.41 257.8 481 257.8 480.49 253.38 484.91 253.38 485.41 257.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.81 252.5 480.39 252.5 480.26 251.35 484.68 251.35 484.81 252.5",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.14 252.5 485.73 252.5 485.6 251.35 490.01 251.35 490.14 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "495.47 252.5 491.06 252.5 490.93 251.35 495.34 251.35 495.47 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "500.81 252.5 496.39 252.5 496.26 251.35 500.68 251.35 500.81 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.14 252.5 501.73 252.5 501.6 251.35 506.01 251.35 506.14 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.48 252.5 507.06 252.5 506.93 251.35 511.35 251.35 511.48 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.81 252.5 512.4 252.5 512.27 251.35 516.68 251.35 516.81 252.5",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "490.74 257.8 486.33 257.8 485.83 253.38 490.24 253.38 490.74 257.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.08 257.8 491.66 257.8 491.16 253.38 495.58 253.38 496.08 257.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "501.41 257.8 497 257.8 496.5 253.38 500.91 253.38 501.41 257.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.75 257.8 502.33 257.8 501.83 253.38 506.24 253.38 506.75 257.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.08 257.8 507.67 257.8 507.16 253.38 511.58 253.38 512.08 257.8",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "517.41 257.8 513 257.8 512.5 253.38 516.91 253.38 517.41 257.8",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.02 263.17 481.61 263.17 481.1 258.76 485.52 258.76 486.02 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.36 263.17 486.94 263.17 486.44 258.76 490.85 258.76 491.36 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.69 263.17 492.27 263.17 491.77 258.76 496.19 258.76 496.69 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "502.02 263.17 497.61 263.17 497.11 258.76 501.52 258.76 502.02 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.36 263.17 502.94 263.17 502.44 258.76 506.86 258.76 507.36 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.69 263.17 508.28 263.17 507.77 258.76 512.19 258.76 512.69 263.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.03 263.17 513.61 263.17 513.11 258.76 517.52 258.76 518.03 263.17",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "486.63 268.54 482.22 268.54 481.72 264.13 486.13 264.13 486.63 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.97 268.54 487.55 268.54 487.05 264.13 491.46 264.13 491.97 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.3 268.54 492.89 268.54 492.38 264.13 496.8 264.13 497.3 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "502.63 268.54 498.22 268.54 497.72 264.13 502.13 264.13 502.63 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.97 268.54 503.56 268.54 503.05 264.13 507.47 264.13 507.97 268.54",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.3 268.54 508.89 268.54 508.39 264.13 512.8 264.13 513.3 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.64 268.54 514.22 268.54 513.72 264.13 518.13 264.13 518.64 268.54",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.24 273.91 482.83 273.91 482.33 269.5 486.74 269.5 487.24 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.58 273.91 488.16 273.91 487.66 269.5 492.08 269.5 492.58 273.91",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.91 273.91 493.5 273.91 493 269.5 497.41 269.5 497.91 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.25 273.91 498.83 273.91 498.33 269.5 502.74 269.5 503.25 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.58 273.91 504.17 273.91 503.66 269.5 508.08 269.5 508.58 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "513.91 273.91 509.5 273.91 509 269.5 513.41 269.5 513.91 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519.25 273.91 514.84 273.91 514.33 269.5 518.75 269.5 519.25 273.91",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "504.37 264.63 504.69 265.15 505.27 265.23 504.9 265.64 505.07 266.21 504.52 265.94 504.04 266.21 504.07 265.64 503.61 265.23 504.18 265.15 504.37 264.63",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489,264.19a2.22,2.22,0,0,0-2,2.56,2,2,0,0,0,1.17,1.42,3.43,3.43,0,0,0,1.85.14,2.65,2.65,0,0,0,1.57-.76,1.67,1.67,0,0,0,.39-1.65,1.9,1.9,0,0,0-1.38-1.24,3.3,3.3,0,0,0-1.87,0,3.27,3.27,0,0,1,1.89-.12,2.12,2.12,0,0,1,1.51,1.32,1.86,1.86,0,0,1-.38,1.84,2.82,2.82,0,0,1-1.67.84,3.72,3.72,0,0,1-2-.19,2.19,2.19,0,0,1-1.26-1.59,2.21,2.21,0,0,1,.5-1.79A2.31,2.31,0,0,1,489,264.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.54,258.8a2.22,2.22,0,0,0-2.19,2.38,1.94,1.94,0,0,0,1.06,1.49,3.47,3.47,0,0,0,1.85.28,2.69,2.69,0,0,0,1.64-.62,1.66,1.66,0,0,0,.52-1.61,1.93,1.93,0,0,0-1.29-1.33,3.31,3.31,0,0,0-1.89-.14,3.4,3.4,0,0,1,1.92,0,2.06,2.06,0,0,1,1.41,1.42,1.79,1.79,0,0,1-.53,1.78,2.86,2.86,0,0,1-1.74.71,3.87,3.87,0,0,1-2-.34,2.15,2.15,0,0,1-1.15-1.67,2.2,2.2,0,0,1,.64-1.73A2.4,2.4,0,0,1,504.54,258.8Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "581.05 349.34 578.92 362.1 564.51 439.92 562.19 439.92 572.67 362.1 574.22 349.34 581.05 349.34",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "574.22 349.34 581.05 349.34 578.92 362.1 572.67 362.1 574.22 349.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.31 439.92 623.99 439.92 609.57 362.1 607.45 349.34 614.28 349.34 615.83 362.1 626.31 439.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "614.28 349.34 615.83 362.1 609.57 362.1 607.45 349.34 614.28 349.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "669.54 439.92 667.21 439.92 652.8 362.1 650.67 349.34 657.51 349.34 659.06 362.1 669.54 439.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "659.06 362.1 652.8 362.1 650.67 349.34 657.51 349.34 659.06 362.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.85 355.33 560.25 355.33 560.25 344.2 599.78 344.2 613.07 266.9 661.83 266.9 665.85 355.33",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.85 355.33 660.1 355.33 656.34 266.9 661.83 266.9 665.85 355.33",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74,453.14c2.1.26,59.8-11.69,61.66-13.49.23-.2-.74-5.44-2.19-12.59l0-.14c-.9-4.54-16.51-41.45-16.51-41.45l-37.45,9.25L579.1,429s-7.14,4.84-13.28,9.45c0,0,0,0,0,0a80.29,80.29,0,0,0-7.76,6.22C556.23,446.88,555.64,452.89,557.74,453.14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.74,453.13c2.09.27,59.8-11.68,61.67-13.48.22-.2-.75-5.44-2.2-12.59l0-.14c-.32-1.69-2.71-7.89-5.57-15-6.16,1.46-28.24,6.73-36.27,8.95L579.1,429s-7.14,4.84-13.28,9.45c0,0,0,0,0,0a80.29,80.29,0,0,0-7.76,6.22C556.23,446.89,555.64,452.89,557.74,453.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.54,453.4c2.16.25,59.91-11.85,61.82-13.7.73-.7-.27-9.78-3.12-19.46L579,428.08s-19.31,14.38-21.19,16.64S555.38,453.15,557.54,453.4Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.89,450.92c9.63-2.27,48.69-10.5,58.38-12,.08,0,.09,0,0,.06-9.5,2.46-48.62,10.37-58.36,12.11C557.71,451.11,557.68,451,557.89,450.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.18,429.69c3.86-.87,8.64-.44,11.71,2.22.12.11,0,.27-.15.24a54.76,54.76,0,0,0-11.53-2A.25.25,0,0,1,576.18,429.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.43,431.48c3.87-.86,8.65-.44,11.72,2.23.12.1,0,.27-.16.23a54.78,54.78,0,0,0-11.52-2A.25.25,0,0,1,573.43,431.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.69,433.27c3.86-.86,8.64-.44,11.71,2.23.12.1,0,.27-.16.23a55.43,55.43,0,0,0-11.52-2A.25.25,0,0,1,570.69,433.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.94,435.07c3.86-.87,8.64-.44,11.71,2.22.12.11,0,.27-.15.24a54.76,54.76,0,0,0-11.53-2A.25.25,0,0,1,567.94,435.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.54,453.4c.67.08,6.75-1,14.85-2.68L567.18,437c-4.4,3.4-8.54,6.69-9.36,7.68C556,447,555.38,453.15,557.54,453.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.61,429.93l39.75-9.39s-34.18-78.32-31.27-82.19c1.46-1.93,38.47-2.5,50.24-12.49,15.29-13,5-32.79,5-32.79L600,291.84s.5,8.65-1.11,10c-1.07.87-50.32,5-55.72,21.63C536.56,343.8,577.61,429.93,577.61,429.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.62,423.77c1-.49,11.34-3.51,13.65-4.1,4.65-1.2,9.31-2.36,14-3.43,2.44-.56,7.67-1.78,8-1.72.15,0,.18.29,0,.34-4.54,1.49-9.14,2.76-13.74,4s-20.44,5.1-21.82,5.19C577.6,424.1,577.48,423.84,577.62,423.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579,334.93a6.27,6.27,0,0,1,3.12-1q9-1.49,17.9-3c5.58-.94,11.19-1.77,16.75-2.84,4.6-.89,9.28-2.09,13.26-4.59a19.24,19.24,0,0,0,8.13-10.64,34.32,34.32,0,0,0,1.05-13.64c-.11-1.11-.31-2.22-.52-3.32,0-.08.12-.11.13,0,1.52,8.48,1.65,18.32-4.69,25.07-3.1,3.29-7.35,5.23-11.69,6.48a131.66,131.66,0,0,1-15,2.93l-17.9,3c-2.87.47-5.79.85-8.63,1.44a3,3,0,0,0-1.56.69,2.23,2.23,0,0,0-.25,2.07c.29,1.41.67,2.8,1.07,4.18,3.26,11.13,28.31,70.09,29,71.31a.11.11,0,0,1-.2.1c-5.47-9.76-24.47-56.63-28.09-67.15a68.51,68.51,0,0,1-2.35-8.2C578.27,336.8,578.15,335.67,579,334.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.62,455.64c2,.68,60.93.46,63.11-.94.26-.15.35-5.48.36-12.77v-.15c0-4.62,1.44-44.11,1.44-44.11l-36.88-.3-2.3,38.88s-8,3.32-14.89,6.62v0a82.08,82.08,0,0,0-8.85,4.55C498.38,449.21,496.61,455,498.62,455.64Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.61,455.64c2,.67,60.94.46,63.12-.94.26-.15.36-5.48.37-12.77v-.14c0-.32,0-.65,0-1s0-.48,0-.71,0-.7,0-1.06c.08-3.07.24-8.05.42-13.51L525,425.28l-.65,11s-8,3.33-14.89,6.62l0,0a84.19,84.19,0,0,0-8.84,4.54C498.39,449.21,496.61,455,498.61,455.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.37,455.86c2.07.68,61.07.32,63.31-1.11.85-.54,1.68-9.65.81-19.7l-38,.28s-21.79,10.24-24.08,12.08S496.31,455.19,498.37,455.86Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.2,453.5c9.89-.3,49.81-.59,59.61-.14.08,0,.08.06,0,.06-9.8.51-49.72.48-59.61.24C499,453.66,499,453.51,499.2,453.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.36,436.34c4-.08,8.55,1.29,11,4.51.1.12-.08.26-.2.2a55.06,55.06,0,0,0-10.9-4.23A.24.24,0,0,1,521.36,436.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.31,437.55c4-.08,8.56,1.29,11,4.51.09.12-.09.26-.2.2A55.14,55.14,0,0,0,518.24,438,.25.25,0,0,1,518.31,437.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.26,438.76c4-.08,8.56,1.29,11,4.51.09.12-.09.26-.2.2a55.06,55.06,0,0,0-10.9-4.23A.24.24,0,0,1,515.26,438.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.21,440c4-.08,8.56,1.29,11,4.51.09.12-.08.26-.2.2a55.06,55.06,0,0,0-10.9-4.23A.24.24,0,0,1,512.21,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.3,436.81l41.6,0s-.53-77.05,2.73-81.22c4.35-5.56,65.16-5.43,78.21-23.56,11.71-16.28,1.82-39.32,1.82-39.32l-46-1.36a94,94,0,0,0,4.27,14.5s-55.48,10.24-71,27.26C523.37,344.61,522.3,436.81,522.3,436.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.78,302.71a22.45,22.45,0,0,1,3.9,1.26c1.32.5,2.62,1.07,3.9,1.69a79.06,79.06,0,0,1,7.28,4.12.07.07,0,0,1-.07.11c-2.49-1.29-5.07-2.45-7.64-3.57l-3.72-1.6c-1.25-.54-2.58-1-3.77-1.66C596.51,303,596.59,302.68,596.78,302.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.54,291.35c.52,2.1,1,4.22,1.59,6.3.27,1,.55,1.93.91,2.86s.76,1.67,1.67,1.85,1.34-.7,1.26-1.56-.34-1.92-.53-2.87-.44-2.18-.64-3.28c-.1-.55-.21-1.09-.3-1.64,0-.14-.12-1.19-.2-1.49,0,0,0,.05-.06,0h0s-.06,0-.07-.06,0-.1.06-.15a.06.06,0,0,1,.09,0c.2.11.22.38.28.58.17.54.34,1.07.5,1.6.29,1,.57,2,.83,3l.75,3a4.62,4.62,0,0,1,.2,2.33,1.79,1.79,0,0,1-1.65,1.35,2,2,0,0,1,.11.2c.09.21.16.43.24.64s.15.44.21.66a3,3,0,0,1,.07.32c0,.13,0,.24,0,.37a.18.18,0,0,1-.33.11c0-.1-.13-.19-.19-.29a1.54,1.54,0,0,1-.15-.35c-.07-.21-.14-.42-.19-.64s-.12-.42-.16-.64,0-.26,0-.39a2.41,2.41,0,0,1-1.21-.46,4,4,0,0,1-1.25-1.92c-.32-.87-.57-1.78-.81-2.68a39,39,0,0,1-1.34-6.77A.19.19,0,0,1,599.54,291.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.93,296.49c.19,1,.31,2.1.55,3.13a31.2,31.2,0,0,0,.84,3,10.85,10.85,0,0,0,1.28,2.71,10.31,10.31,0,0,0,2,2.08,17.61,17.61,0,0,0,4.94,2.75,23.84,23.84,0,0,0,2.74.8c.49.11,1,.2,1.47.26a3.13,3.13,0,0,1,1.18.27.24.24,0,0,1,0,.41,4.27,4.27,0,0,1-2.19.07,15.58,15.58,0,0,1-2.33-.41,16.61,16.61,0,0,1-4.41-1.86,13.88,13.88,0,0,1-3.68-3,10.37,10.37,0,0,1-2-4.32,21.59,21.59,0,0,1-.65-5.87A.11.11,0,0,1,626.93,296.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.91,382.79q.62-9.81,1.63-19.58c.17-1.61.33-3.22.53-4.83a14.9,14.9,0,0,1,.81-3.66c1-2.45,3-3.69,5.46-4.31,2.91-.74,5.92-1.18,8.88-1.66s6.06-.92,9.1-1.35c6.15-.85,12.31-1.65,18.43-2.68a145.33,145.33,0,0,0,18.08-4.07c5.44-1.64,11-3.67,15.38-7.45,9.37-8.12,9.71-21.74,8.57-33.13-.16-1.61-.36-3.22-.55-4.82,0-.08.12-.11.12,0,.75,6.42,1.61,12.87,1,19.33a31.62,31.62,0,0,1-5.12,15c-3.17,4.55-7.88,7.49-13,9.54A101.24,101.24,0,0,1,610,344c-12.15,2.55-24.55,3.63-36.78,5.72-1.51.26-3,.53-4.52.83a18.48,18.48,0,0,0-4.08,1.09c-2.77,1.24-3.54,3.95-3.88,6.74-.8,6.49-1.34,13-1.81,19.54-.95,13.14-1.45,26.35-1.43,39.53,0,1.62,0,9,0,10.61,0,.14-.22.13-.22,0C556.91,414.89,557.09,396,557.91,382.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.25,430.65a23.39,23.39,0,0,1,3.45-.29c1.21-.07,2.42-.14,3.63-.19,2.38-.1,4.77-.16,7.15-.17,4.8,0,9.61,0,14.41.11,2.5.05,7.87.15,8.17.29.14.06.11.32,0,.33-4.77.34-9.54.45-14.31.56s-9.53.21-14.3.1c-1.32,0-2.64-.11-4-.15a29.1,29.1,0,0,1-4.17-.26C524.14,431,524.09,430.68,524.25,430.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564,385.45c.07-4.49.19-9,.29-13.48.1-4.24,0-8.55.83-12.73.33-1.68.63-3.91,2.44-4.69a21.14,21.14,0,0,1,2.94-.87c1.07-.28,2.13-.55,3.21-.78,5-1.07,10-1.75,15-2.42.09,0,.13.12,0,.14-4.25.82-8.51,1.65-12.73,2.61-2.11.48-4.22,1-6.3,1.56a5.18,5.18,0,0,0-2.63,1.11,6.93,6.93,0,0,0-1,2.84c-1,4.1-.9,8.38-1,12.56-.12,4.34-.22,8.68-.35,13-.14,4.87-.27,9.75-.6,14.61,0,.13-.21.13-.21,0C563.83,394.44,564,389.94,564,385.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.59,306a155,155,0,0,0-25.13,5.15,175.81,175.81,0,0,0-24.24,8.78c-4.4,2-8.67,4.2-12.9,6.52-.08.05,0,.17.08.13A196.42,196.42,0,0,1,566,316.27a190.8,190.8,0,0,1,24.55-7.12c4.7-1,9.42-1.82,14.16-2.61C605,306.49,604.91,306,604.59,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608,243c-4.85,17.21-16.61,37.86-19.57,38.91-5.23,1.86-38.77.8-40.08.54-3.22-.67-4.88-22.92-1.93-24.85.67-.44,36.25,4.4,37.64,4.15,1.7-.31,6.79-12.32,16.12-22.88C606.77,231.45,610.6,233.85,608,243Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.53,281.77a78.27,78.27,0,0,1-10,2.25c-2.67.31-10.39,1-11-1.92-.43-2,4.06-2.91,7.22-3.64,1.66-.39,3.85-1.69,3.56-2.76-.5-1.89-4.8-.81-7.69.27-5.59,2.1-13.27,6.28-15.94,3.17-1-1.18.66-2.72,2.95-4.13-3.58,1.49-7.32,2.57-8.49,1.31a1.72,1.72,0,0,1,0-2.38,2.3,2.3,0,0,1-2.43-.82c-.87-1.28-.08-2.81,1.35-4.29a1.27,1.27,0,0,1-.85-.79c-1.65-3.77,11.16-11.64,15.17-11.9a87.18,87.18,0,0,1,23.72,2.24C554,262.7,552.54,281.77,552.53,281.77Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.63,268.37a18.66,18.66,0,0,0-8.07,1.63c-2.95,1.37-5.48,3.5-8.28,5.14-.07.05,0,.17.08.12,1.33-.87,2.76-1.61,4.12-2.42s2.65-1.65,4-2.35a18.8,18.8,0,0,1,8.11-2.08A0,0,0,1,0,537.63,268.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.33,263.19a46.76,46.76,0,0,0-9.33,1.56c-3.29,1-6.09,3.15-8.83,5.18q-2.48,1.83-4.86,3.76c-.06.06,0,.17.08.12,2.78-2.1,5.64-4.13,8.55-6.06a24.68,24.68,0,0,1,8.89-3.7c1.82-.36,3.66-.58,5.5-.8C536.36,263.24,536.36,263.19,536.33,263.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.85,258.44a23.71,23.71,0,0,0-8.44,1.31,41.79,41.79,0,0,0-9,5.42c-1.51,1.14-3,2.33-4.41,3.55-.06,0,0,.15.09.1a97.66,97.66,0,0,1,10.32-7.26,19.41,19.41,0,0,1,5.49-2.38,34.57,34.57,0,0,1,5.92-.72S533.86,258.44,533.85,258.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.26,255.81l-3,28s27.39,1.87,36.56-.95c4.93-1.52,16.94-29.28,19.64-38.78,2.65-9.34-.09-15.5-8.15-6.56-7.61,8.43-15.23,22.84-16.14,23.17S555.26,255.81,555.26,255.81Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.62,269.92c.19-2,.38-3.95.55-5.92s.41-4,.43-5.94c0-.08-.14-.12-.16,0-.38,1.87-.55,3.81-.79,5.7s-.49,4-.72,6.05c-.46,4-.75,8-1,12a.08.08,0,0,0,.15,0C558.7,277.83,559.24,273.89,559.62,269.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.42,244.08c-2.7,9.5-14.71,37.26-19.64,38.78a49.13,49.13,0,0,1-11,1.41c8-14.79,19.25-35.73,27.54-50.82C609.37,231.88,610.4,237.09,608.42,244.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.29,302.46s58.78,2.15,59,1.74S638,240,616,232.08c-3.5-1.26-9.19-.75-12.62,2.36C593.21,243.65,591.37,301.7,592.29,302.46Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.9,261c0-.25,0-.51,0-.75,0-.48.05-.95.08-1.42.07-.95.19-1.89.31-2.83,0,0,.06,0,.06,0,0,.89,0,1.78-.08,2.66.55-3.13,1.12-6.27,1.8-9.36,0-.06.08,0,.07,0-.46,3.48-1.06,6.95-1.61,10.41s-3.61,38.93-3.38,42.85c0,.09-.1.12-.1,0C591.56,295.72,593.72,267.91,594.9,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.29,237.21c11.49,13.81,25.35,39.35,22.54,46-3.74,8.85-46.08,14.38-53.1,14.9-3,.22-.87-27,2.33-27.26,2.78-.27,26.07-2.88,27.06-4.25.58-.8-2.57-8.4-7.1-26.95C612.1,227.67,620.15,233.45,623.29,237.21Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,272.43s-1.65-.16-10.22-2.45c-5.93-1.59-21.37-1.66-31.59,12.23-3.91,5.32-1.88,10.39,3.16,5.58,3.56-3.38,5.73-6,7.2-6.81,0,0-1,7.44,2.14,10.43a79.61,79.61,0,0,0,8.84,7.2,16.48,16.48,0,0,0,1.49-1.53,9.17,9.17,0,0,0,9.7,1Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.89,269.37c-2.88,1.42-8.95,4.52-13,8.79-4.52,4.74-12,15.09-8.44,18.39,2.59,2.43,5.78-1.27,5.78-1.27s-2.17,4.92.64,6.6c2.57,1.53,4.87-1.48,4.87-1.48s-.81,3.22,1.95,4.21c3.32,1.2,4.46-5.73,8.87-7.42C587.52,296.81,585.89,269.37,585.89,269.37Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.67,282.11a26.07,26.07,0,0,0-8.51,13c0,.13.05.22.1.11a64.73,64.73,0,0,1,8.45-13.11S578.7,282.09,578.67,282.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.32,286.82c-2,1.75-6.51,7.63-7.72,13.52,0,.13.07.22.12.11a68.5,68.5,0,0,1,7.65-13.59S583.35,286.8,583.32,286.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.87,270l9.59,27.71s38-5.57,42.07-13.34c3.37-6.53-11.58-32.78-17-40.11-11-14.74-17.25-15.77-15.15-4.83,2.44,12.71,7.09,26,6.48,26.68S594.87,270,594.87,270Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.24,283.37c-.7-2.05-1.41-4.11-2.14-6.16s-1.37-4.13-2.23-6.11a.08.08,0,0,0-.16,0c.49,2,1.19,4.05,1.82,6.05s1.33,4.24,2,6.36c1.34,4.18,2.84,8.3,4.41,12.39,0,.1.16,0,.14-.06C607.9,291.68,606.65,287.51,605.24,283.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,269.65c8.63-1.43,17.35-2.25,26-3.65-.88-3.36-2-6.66-3-10-.17-.6-.33-1.2-.49-1.8-.8-1.58-1.57-3.18-2.28-4.81a0,0,0,0,1,0,0c.7,1.31,1.35,2.63,2,4-.71-2.58-1.4-5.17-2.09-7.76a0,0,0,1,1,.09,0c1.11,3.42,2.23,6.83,3.28,10.26s1.91,6.94,3.05,10.34a.28.28,0,0,1-.18.37c-4.33.86-8.74,1.38-13.12,2s-8.73,1.18-13.12,1.55v.72a.13.13,0,0,1-.25,0c0-.3-.09-.6-.13-.91A.18.18,0,0,1,595,269.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.13,296.76c.08.17.27.81.27.81.24,0,2.5-.4,3.26-.51,1.38-.21,2.75-.44,4.11-.68,2.87-.49,5.72-1.07,8.55-1.7a152.84,152.84,0,0,0,16.2-4.34c2.44-.81,7.46-2.74,9.7-5.72.68-.9.69-.15-.32,1.15a15.14,15.14,0,0,1-6,4.11,61,61,0,0,1-7.71,2.53q-4.2,1.17-8.46,2.14c-3.18.74-6.38,1.38-9.6,1.95-1.59.28-3.19.55-4.79.8a45.08,45.08,0,0,1-5,.64,10.89,10.89,0,0,1-.3-1.16C603.92,296.69,604.09,296.68,604.13,296.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.9,242.61c4.3.62,9.1-5.09,10.68-9.48a68.84,68.84,0,0,0-1.69-6.68c-.54-2.13-1.1-4.53-1.45-6.74l-13.39,5.57a35.33,35.33,0,0,1,2.69,8.31,4.86,4.86,0,0,1,0,.92v.16C602.78,236.44,602.66,242.13,605.9,242.61Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.06,225.28a36.05,36.05,0,0,1,2.68,8.31,4.86,4.86,0,0,1,0,.92.38.38,0,0,0,0,.15,6.92,6.92,0,0,0,1.44-.14c8.41-1.71,8.67-11.74,8.58-14.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.26,204.62c1.67,4.95-.53,19.46-4,22.79-5,4.81-13.43,5.51-17.57-.56-4-5.88-.82-24.74,3.06-27.78C601.48,194.58,611.78,197.31,614.26,204.62Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,217.62c-.8,4.29-2.13,8.24-3.74,9.79-5,4.81-13.42,5.51-17.57-.56-2.53-3.7-2.2-12.55-.64-19.36v0c.93-4,2.26-7.27,3.7-8.4,5.71-4.47,16-1.74,18.5,5.56C615.15,207.28,614.94,212.67,614,217.62Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.1,214.06s.07.06.06.1c-.2,1-.26,2.09.56,2.57,0,0,0,.06,0,.05C599.66,216.44,599.76,214.94,600.1,214.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.14,213.2c1.58.15,1.16,3.29-.3,3.15S599.82,213.07,601.14,213.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.39,213.29s-.08,0-.09.07c-.1,1-.38,2.08-1.3,2.29a0,0,0,0,0,0,0C594.1,215.69,594.45,214.23,594.39,213.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.65,212.15c-1.54-.32-2.09,2.8-.65,3.1S595,212.43,593.65,212.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.14,212c-.42-.17-.77-.39-1.16-.59a2.11,2.11,0,0,1-1.07-.83.68.68,0,0,1,.21-.79,1.68,1.68,0,0,1,1.69.05,2.46,2.46,0,0,1,1.25,1.23A.72.72,0,0,1,602.14,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.65,210.41a11.09,11.09,0,0,0,1.29-.16,2,2,0,0,0,1.29-.41.66.66,0,0,0,.07-.81,1.64,1.64,0,0,0-1.6-.53,2.45,2.45,0,0,0-1.6.72A.72.72,0,0,0,592.65,210.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,222.79c-.22.25-.43.58-.78.63a2.62,2.62,0,0,1-1.07-.18,0,0,0,0,0,0,0,1.31,1.31,0,0,0,1.27.45,1,1,0,0,0,.72-.91C600.09,222.77,600,222.76,600,222.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.13,219.83a3.35,3.35,0,0,1-2.41,1.18,4.36,4.36,0,0,1-1.19-.1l-.44-.12a.24.24,0,0,1-.16-.25h0s.34-2.08.34-2.08c-.29.11-1.77.55-1.7.16a50.7,50.7,0,0,1,2.62-9.86.09.09,0,0,1,.18.05c-.48,3.12-1.5,6.12-2,9.24a5.86,5.86,0,0,1,1.63-.26c.06,0-.48,2.53-.48,2.55a4.63,4.63,0,0,0,3.57-.61C599.13,219.68,599.2,219.76,599.13,219.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,220.53a3.93,3.93,0,0,0,1.41,1.4,1.81,1.81,0,0,0,1.06.2c.8-.11.9-.81.84-1.43a4.12,4.12,0,0,0-.23-1A5.13,5.13,0,0,1,596,220.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.44,221.93a1.81,1.81,0,0,0,1.06.2c.8-.11.9-.81.84-1.43A1.83,1.83,0,0,0,597.44,221.93Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614,217.62c-1.23.27-2.85-.36-3-.25s-2.05,0-2.06-1.45,2.07-10.8-2.86-12.6c-3.45-1.27-5.44.94-8.11.44-2-.37-2.08-1.94-3.17-1.68s-2.13,3.46-2.72,5.41v0c.93-4,2.26-7.27,3.7-8.4,5.71-4.47,16-1.74,18.5,5.56C615.15,207.28,614.94,212.67,614,217.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.26,217.3s3.22-4.7,5.35-3.56-.26,7.93-2.73,8.88a2.53,2.53,0,0,1-3.41-1.32Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.88,215.67s0,.05,0,.07a6.35,6.35,0,0,0-3.26,4,1.39,1.39,0,0,1,2.08-.4s0,.1,0,.09A1.55,1.55,0,0,0,612,220a7.42,7.42,0,0,0-.81,1.39c-.08.16-.36.08-.3-.1v0C610.8,219.05,612.49,215.92,614.88,215.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.79,234.29l3.28,8.31,10.37-10.42,2.89,3.39s-10.18,16.59-10.24,15.84l-3.37-7.17-5,4.94.48-12.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.65,243c.14-2.05.24-4.13.48-6.18,0-.07.12-.1.14,0,.4,2-.21,9.86-.21,11.74l0,0c.21-.21,4.6-4.34,4.64-4.28.73,1.14,3.21,6.36,3.38,6.84,1.61-2.64,7.78-12.22,9.68-14.71a.07.07,0,0,1,.12.07c-1.42,2.78-9.59,15.69-9.71,15.65a80,80,0,0,1-3.53-7.57c-.74.9-5.18,5.56-5.19,5.26A63.89,63.89,0,0,1,600.65,243Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.43 349.34 386.3 362.1 371.89 439.92 369.57 439.92 380.05 362.1 381.6 349.34 388.43 349.34",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.6 349.34 388.43 349.34 386.3 362.1 380.05 362.1 381.6 349.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.69 439.92 431.36 439.92 416.95 362.1 414.82 349.34 421.66 349.34 423.21 362.1 433.69 439.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.66 349.34 423.21 362.1 416.95 362.1 414.82 349.34 421.66 349.34",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.91 439.92 474.59 439.92 460.18 362.1 458.05 349.34 464.88 349.34 466.43 362.1 476.91 439.92",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.43 362.1 460.18 362.1 458.05 349.34 464.88 349.34 466.43 362.1",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.23 355.33 367.63 355.33 367.63 344.2 407.16 344.2 420.44 266.9 469.2 266.9 473.23 355.33",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.23 355.33 467.47 355.33 463.72 266.9 469.2 266.9 473.23 355.33",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.15,206.65c-7.74,7.48-4.86,17.54-7.94,23.27-1.88,3.51-8.45,7.49-9.57,11.46-1.83,6.54,3.74,8.51,2.73,12.07-1.43,5-8.05,5-8.76,13.18s8.68,16.19,29.88,17.25,32.32-7.33,32.67-14.22-6.8-8.75-7.58-13.83c-.5-3.25,3.69-5.78,3.55-11.81s-6.12-7.62-7.26-12.68.82-17.62-7.06-23.5S428,203,424.15,206.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.1,206.78a17.41,17.41,0,0,0-5,6.57,38.78,38.78,0,0,0-2.52,8.45,22.62,22.62,0,0,1-1.34,5.06,12.6,12.6,0,0,1-2.62,3.66c-2.15,2.2-4.78,3.92-6.69,6.36s-3.14,5.34-2.18,8.28c.51,1.6,1.67,2.86,2.42,4.34s1.08,3.17-.08,4.44c-1,1.08-2.49,1.64-3.64,2.55a13.63,13.63,0,0,0-2.9,3.16,10.35,10.35,0,0,0-1.45,8.22c1.63,6.48,8,9.84,13.82,11.84.81.28,1.62.56,2.44.82.12.05.21-.14.09-.19-5.85-2.2-12.64-4.8-15.21-11a9.59,9.59,0,0,1,.48-8.51,12.27,12.27,0,0,1,2.82-3.35c1.09-.92,2.39-1.51,3.5-2.39a3.88,3.88,0,0,0,1.59-3.56,9.61,9.61,0,0,0-1.82-4.1,7.8,7.8,0,0,1-1.61-4.33,8.46,8.46,0,0,1,1.44-4.31c1.62-2.62,4.15-4.42,6.39-6.46a14.33,14.33,0,0,0,4.7-7.4c.35-1.53.52-3.09.81-4.63a40.84,40.84,0,0,1,1-4.24,19.88,19.88,0,0,1,4-7.6,11.52,11.52,0,0,1,1.66-1.54A.06.06,0,1,0,425.1,206.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.79,264.58a7.86,7.86,0,0,0-1.64-3c-.79-.88-1.72-1.61-2.58-2.42a5.94,5.94,0,0,1-1.89-2.74,5.66,5.66,0,0,1,.7-3.85,28.15,28.15,0,0,0,1.66-3.78,13.13,13.13,0,0,0,.57-4,13.5,13.5,0,0,0-2.59-7.71c-.78-1.13-1.66-2.2-2.46-3.33a17.06,17.06,0,0,1-2.11-4c-1.14-3.11-1.54-6.45-2.51-9.61a50.39,50.39,0,0,0-4-9.35c0-.08-.15,0-.11.07a43.31,43.31,0,0,1,3.51,8.45c.84,2.78,1.27,5.64,1.93,8.46a18.45,18.45,0,0,0,3.36,7.45c1.56,2.24,3.17,4.44,3.72,7.17a12.88,12.88,0,0,1-.88,8c-1,2.17-2.4,4.57-1.29,7,.95,2,3,3.15,4.42,4.8a8.32,8.32,0,0,1,1.82,6.57c-.78,6-6.52,9.24-12,9.87a.13.13,0,1,0,0,.26c4.81-.34,9.91-2.77,11.9-7.41A10.18,10.18,0,0,0,463.79,264.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,454c2.1-.28,54.71-26.54,56-28.75.17-.25-2.1-5.06-5.32-11.59-7.28-14.8-21.83-39.81-21.83-39.81l-31.67,17.8,17.44,33s-5.86,7.08-10.61,13.1v0a82,82,0,0,0-5.89,8C374,448.33,375,454.27,377,454Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,454c2.1-.28,54.71-26.54,56-28.75.17-.25-2.1-5.06-5.32-11.59-11.69,9.2-44.33,30.69-46.67,28.44-.93-.9-.7-2.55,0-4.3a82,82,0,0,0-5.89,8C374,448.33,375,454.27,377,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.44,421.73l36.69-19.37s-28-54.86-27.26-55.82c2.57-3.31,33.57-1.8,47-15.11,14.18-14.09,3.35-34.15,3.35-34.15h-37s.34,10.05-1.25,11.36c-1.06.88-55.52,6.13-57.65,20.5C345.55,354,385.44,421.73,385.44,421.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.15,414.89c4.41-2.67,8.94-5.12,13.48-7.57s9.1-4.83,13.72-7.12c2.6-1.29,5.26-2.45,7.87-3.74.08,0,.15.09.07.13-2.29,1.23-4.51,2.57-6.79,3.81s-4.5,2.44-6.75,3.63c-4.56,2.42-9.14,4.78-13.7,7.17-2.58,1.34-5.18,2.61-7.81,3.86A.1.1,0,0,1,383.15,414.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.28,340.45c.91-1.88,3.33-2.16,5.13-2.61l14.78-3.68c8.73-2.16,17.72-4.2,25.54-8.82,3.74-2.21,7.36-5,9.23-9s1.86-8.33,1.89-12.58c0-1.06-.06-2.11-.12-3.16,0-.09.13-.09.14,0,.27,4.19.7,8.38-.24,12.53a16.82,16.82,0,0,1-2.35,5.65,19.28,19.28,0,0,1-4.26,4.48c-6.91,5.42-15.59,8-24,10.16-4.75,1.21-9.5,2.36-14.26,3.53l-7.34,1.79a6.89,6.89,0,0,0-3,1.19,3.18,3.18,0,0,0-.91,2.66,10.13,10.13,0,0,0,.75,2.92c.44,1.15.9,2.29,1.37,3.44.9,2.23,1.83,4.44,2.78,6.65q2.88,6.68,6,13.26c4.12,8.74,8.52,17.35,13,25.91.56,1.07,1.1,2.14,1.65,3.21,0,.07-.07.12-.1.06-4.81-8.46-9.3-17.12-13.57-25.86s-8.29-17.49-11.72-26.52C380.07,344.05,379.49,342.08,380.28,340.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,455.93c2,.66,60.81,0,63-1.37.26-.16.28-12.75.28-12.75,9.65-21.92,18.39-43.13,18.39-43.13l-41.1-.05L300.57,436s-8.36,3.81-15.26,7.15l0,0a83.24,83.24,0,0,0-8.79,4.59C274.29,449.51,272.57,455.28,274.57,455.93Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.57,455.93c2,.66,60.81,0,63-1.37.26-.16.32-5.47.28-12.75-14.54,3.17-53.28,8.24-54.41,5.18-.44-1.21.49-2.59,1.88-3.86a83.24,83.24,0,0,0-8.79,4.59C274.29,449.51,272.57,455.28,274.57,455.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.59,428.07l44.39-.32s22.32-57.49,25.93-61.35c1.82-1.95,14-4.13,28.62-7.33h.08c5.39-1.19,11.11-2.51,16.73-4,14.64-3.9,28.73-9,35.14-16.14,13.42-14.82,0-41.62,0-41.62H416.69s-.94,11.66,1.95,18.8c0,0-27.8,4.09-51.22,11.68-13.27,4.31-25.12,9.75-29.71,16.22C328.74,356.62,303.59,428.07,303.59,428.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,421.42c5.14-.38,10.28-.51,15.44-.64s10.3-.17,15.46-.12c2.9,0,5.8.2,8.71.24a.07.07,0,0,1,0,.14c-2.59.06-5.18.25-7.78.32s-5.11.13-7.66.18c-5.16.08-10.31.11-15.46.16-2.91,0-5.8,0-8.71-.09A.1.1,0,0,1,308.61,421.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.24,302.78a2.28,2.28,0,0,0,.21.51.07.07,0,0,1,0,.09c.5,1.54.71,3.19,1.19,4.74a7.48,7.48,0,0,0,2.87,4.1c2.93,2,6.46,2.95,9.86,3.8a.1.1,0,0,1,0,.19,19.21,19.21,0,0,1-5.82-.89,15.52,15.52,0,0,1-4.9-2.35,7.69,7.69,0,0,1-2.81-4.24,23,23,0,0,1-.49-2.73,21.32,21.32,0,0,1-.35-3.19A.15.15,0,0,1,435.24,302.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,313.48a44,44,0,0,1,6.8,2.59l.1.05a2,2,0,0,1-.1-.41l-.08-.49a4.36,4.36,0,0,1-.05-.52l0-.26v0a2.06,2.06,0,0,1-1.46-.74,5.36,5.36,0,0,1-.91-2.14c-.26-1-.49-1.94-.7-2.92s-.44-2.18-.61-3.28a20.87,20.87,0,0,1-.37-3.25.15.15,0,0,1,.3,0c.25,1,.37,2,.56,3.05s.41,2,.64,3,.48,2,.76,3,.5,2.18,1.53,2.47c2.12.61,1.17-4.16,1.07-5.09-.21-2.15-.34-4.35-.72-6.49,0-.09.12-.13.14,0,.46,2,1,3.9,1.33,5.89.17,1,.3,2,.4,2.94a4.53,4.53,0,0,1-.19,2.53,1.85,1.85,0,0,1-1.4,1l.06.22a4.34,4.34,0,0,1,.14.48l.12.48a1.32,1.32,0,0,1,.07.59.25.25,0,0,1-.11.12c.91.4,1.81.79,2.71,1.2a24,24,0,0,1,3.26,1.59c.12.05,0,.22-.09.2a23.72,23.72,0,0,1-3.42-1.24c-1.13-.43-2.25-.89-3.37-1.36a42.26,42.26,0,0,1-6.47-3A.11.11,0,0,1,411.73,313.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.32,400c2.35-5.79,4.81-11.53,7.43-17.2s5.39-11.31,8.28-16.86c1.26-2.41,2.41-4.86,4.93-6.16a18,18,0,0,1,3.63-1.29c1.47-.4,3-.77,4.43-1.15,12-3,24.2-5.55,36.16-8.9,6-1.67,11.9-3.56,17.69-5.82,4.69-1.84,9.38-4,13.28-7.21a21.14,21.14,0,0,0,4.77-5.43c1.48-2.48,4.95-9.23-.18-29.66,0-.09.1-.16.12-.07,4.09,14.55,3.23,22.48,2.48,25.37a18.31,18.31,0,0,1-3.36,6.77c-3,3.87-7.29,6.55-11.67,8.64a122.27,122.27,0,0,1-16.2,6.07c-11.92,3.73-24.14,6.35-36.28,9.23-3,.71-6,1.44-9,2.21-2.68.69-5.81,1.23-7.73,3.41a17.89,17.89,0,0,0-2.24,3.7c-.72,1.39-1.44,2.78-2.14,4.18q-2.18,4.29-4.25,8.63-8.18,17.11-14.9,34.89c-.55,1.46-1.1,2.93-1.67,4.39,0,.11-.21.06-.17-.05C346.67,411.66,349,405.78,351.32,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.57,383.46a109.93,109.93,0,0,1,5.2-12.63c1.18-2.32,2.5-5.08,5.08-6.07a38,38,0,0,1,4.21-1.16c1.48-.38,3-.74,4.47-1.1q4.49-1.06,9-2c3.35-.69,6.73-1.36,10.13-1.72.08,0,.08.12,0,.14-2.87.84-5.81,1.47-8.72,2.17l-8.52,2c-2.91.71-5.82,1.44-8.71,2.2a7.23,7.23,0,0,0-3.41,1.8c-1.3,1.28-7.76,15.42-8.49,16.82C365.6,384.36,365.46,383.89,365.57,383.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.31,334.79a106.05,106.05,0,0,1,13.58-6.44c4.24-1.44,8.57-2.65,12.9-3.83,8.89-2.43,17.91-4.44,27-6.08q3.89-.69,7.77-1.31a67.81,67.81,0,0,1,7.64-.94.08.08,0,0,1,0,.15c-2.25.56-4.56.9-6.84,1.29s-4.5.79-6.75,1.22q-6.74,1.29-13.43,2.81c-8.83,2-17.67,4.2-26.31,6.93-4.59,1.45-11.51,4.79-15.39,6.52A.18.18,0,0,1,349.31,334.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.54,247.43c-6.11,7.74-41.54,37.63-62.58,31.92-7.14-1.93-.66-30.76,19.24-56.45.59-.76,21.52,7.1,20.27,12.27-.13.56-6.71,12.65-6.71,12.65s8.6-2.63,24.27-6.69C433.44,239.21,435.19,242.81,431.54,247.43Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,227.77s4.66-8.36,10.6-12.45c4.11-2.83,10-7.5,23.51-1.22,3.21,1.49,7.87,7.92,5.48,9.59s-5.89-4.89-10.74-6.13c0,0,3.85,5.84,2.24,9a66.12,66.12,0,0,1-4.82,7.94,15.34,15.34,0,0,1-1.56-.77s-1.61,2.9-6.48,4.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,213.25c2.6.3,8.1,1,12.39,3.19,4.76,2.39,13.29,8.3,11.49,11.8-1.33,2.57-4.78.6-4.78.6s3,3.18,1.3,5.24c-1.55,1.87-4.13.19-4.13.19s1.49,2.25-.35,3.76c-2.22,1.83-6.08-4.33-9.92-4.42C405.09,233.59,400,213.25,400,213.25Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,221.05a21.19,21.19,0,0,1,10.08,7.68c.06.09,0,.18-.05.11A52.63,52.63,0,0,0,409,221.09S408.94,221,409,221.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.14,215.9a21.19,21.19,0,0,1,10.08,7.68c.06.09,0,.18-.05.11a52.31,52.31,0,0,0-10.05-7.75S412.12,215.89,412.14,215.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.69,225.93a23.8,23.8,0,0,1,9.6,8.27c.06.09,0,.18-.05.11a56.49,56.49,0,0,0-9.58-8.34S406.66,225.92,406.69,225.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.2,234.74a10.15,10.15,0,0,0-5.71-2.48c-.07,0-.1.1,0,.12,1.65.62,3,1.2,3,1.22-2.53,2.3-6.5,2.84-8.19,2.92-.11,0-.09.17,0,.19,3,.45,6.55-.49,8.4-3a24.2,24.2,0,0,0,2.47,1.11S409.22,234.77,409.2,234.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,234.07l28.09,6.14-4.29,7.61s15.57-4.75,23.88-6.88,10.46,1.77,4.75,8.13-23.88,20.69-37,26.53c-12.19,5.43-20.38,5.6-24.68,3.83S360.69,264.24,378,234.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.87,235.88a.67.67,0,1,1-1.34,0,.65.65,0,0,1,.26-.53h0l1,.21A.66.66,0,0,1,384.87,235.88Zm-10.17,13.6a.67.67,0,1,0,.67.67A.67.67,0,0,0,374.7,249.48Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,384.2,249.48Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,393.7,249.48Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,403.2,249.48Zm9.5,0a.67.67,0,1,0,0,1.34.67.67,0,1,0,0-1.34Zm9.49,0a.67.67,0,0,0,0,1.34.67.67,0,1,0,0-1.34Zm-42.74-6.85a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,379.45,242.63Zm9.5,0a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,389,242.63Zm9.5,0a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,398.45,242.63Zm19.6.38-1.27.37a.67.67,0,0,0,.66.6.68.68,0,0,0,.68-.68A.57.57,0,0,0,418.05,243Zm8.89-.38a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,426.94,242.63ZM365.72,264c-.06.34-.12.67-.17,1a.65.65,0,0,0,.33-.57A.63.63,0,0,0,365.72,264Zm9-.25a.67.67,0,1,0,.67.67A.67.67,0,0,0,374.7,263.75Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,384.2,263.75Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,393.7,263.75Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,403.2,263.75Zm9.5,0a.68.68,0,0,0-.68.67v0l.92-.66A.93.93,0,0,0,412.7,263.75ZM370,256.91a.67.67,0,1,0,0,1.34.67.67,0,1,0,0-1.34Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,379.45,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,389,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,398.45,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,408,256.91Zm9.49,0a.67.67,0,1,0,.68.67A.67.67,0,0,0,417.44,256.91ZM374.7,278a.67.67,0,1,0,.67.67A.67.67,0,0,0,374.7,278Zm9.5,0a.67.67,0,0,0-.67.67.61.61,0,0,0,.15.41l1.18-.33a.22.22,0,0,0,0-.08A.67.67,0,0,0,384.2,278ZM370,271.18a.67.67,0,1,0,0,1.34.67.67,0,1,0,0-1.34Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,379.45,271.18Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,389,271.18Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,398.45,271.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76,247.82q-5.14,9.62-10.74,19c-1,1.74-2.07,3.49-3.1,5.23,0,.06.06.12.1.06a102.32,102.32,0,0,0,6.1-9c1.86-3.09,3.67-6.25,5.21-9.5.89-1.88,1.75-3.76,2.56-5.66A.07.07,0,0,0,401.76,247.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,243.07c-2.08-.47-10.38-2.22-12.47-2.43-.06,0-.07.09,0,.11,2,.71,10.3,2.67,12.38,3.14,4.16.92,8.34,1.91,12.57,2.47.08,0,.12-.12,0-.15C396.86,244.9,392.63,244,388.44,243.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.38,249.07c-5.71,6.37-23.87,20.69-37,26.54-2.32,1-4.52,1.88-6.55,2.55l42.07-37.79C434.4,240,435.27,243.64,430.38,249.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.79,299l54.34,4.61S449.66,257,439.28,244.34c-4.73-5.77-9.75-5.27-14.2-2.06-1.11.81-15.12,16.89-16.6,22.58-1.32,5,2.34,10.55,2.34,10.55Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.29,276.54a46.12,46.12,0,0,0-6.74-.5c-1.12,0-2.23.08-3.35.17-.55.05-1.11.08-1.67.1a7.24,7.24,0,0,1-1.74-.09c-.05,0-.07.07,0,.08a12.65,12.65,0,0,0,1.62.36,12.16,12.16,0,0,0,1.6.08c1.13,0,2.27-.06,3.41-.08,2.29,0,4.58-.07,6.87.07C426.38,276.73,426.39,276.55,426.29,276.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.21,279.78a46.89,46.89,0,0,0-5.35-1.57c-.9-.21-1.82-.36-2.74-.49-.44-.07-.88-.12-1.32-.17s-1,0-1.46-.1c0,0-.07.07,0,.08.45.07.9.21,1.35.31l1.36.29,2.72.59c1.82.38,3.62.77,5.43,1.21C431.28,280,431.3,279.81,431.21,279.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.87,250.15a.68.68,0,0,1-.68.67.67.67,0,0,1,0-1.34A.68.68,0,0,1,422.87,250.15Zm8.82-.67a.67.67,0,1,0,.67.67A.67.67,0,0,0,431.69,249.48Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,249.48Zm-14.25-6.85a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,426.94,242.63Zm9.5,0a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,436.44,242.63ZM412.7,263.75a.67.67,0,1,0,0,1.34.67.67,0,0,0,0-1.34Zm9.49,0a.67.67,0,1,0,0,1.34.67.67,0,1,0,0-1.34Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,431.69,263.75Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,263.75Zm-23.75-6.84a.67.67,0,1,0,.68.67A.67.67,0,0,0,417.44,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,426.94,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,256.91Zm9.65,0h-.15a.67.67,0,1,0,.57,1ZM412.7,278a.67.67,0,1,0,0,1.34.67.67,0,0,0,0-1.34Zm9.49,0a.67.67,0,0,0,0,1.34.67.67,0,1,0,0-1.34Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,431.69,278Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,278Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,450.69,278Zm-33.25-6.84a.67.67,0,1,0,.68.67A.67.67,0,0,0,417.44,271.18Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,426.94,271.18Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,271.18Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,271.18ZM412.7,292.29a.68.68,0,1,0,.67.67A.67.67,0,0,0,412.7,292.29Zm9.49,0a.68.68,0,0,0,0,1.35.68.68,0,1,0,0-1.35Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,431.69,292.29Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,441.19,292.29Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,450.69,292.29Zm-42.11-6.39-.14.67a.67.67,0,0,0,.18-.45A.54.54,0,0,0,408.58,285.9Zm8.86-.45a.67.67,0,1,0,.68.67A.67.67,0,0,0,417.44,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,426.94,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,285.45Zm9.58,0h-.08a.67.67,0,0,0,0,1.34.61.61,0,0,0,.41-.15C455.74,286.25,455.64,285.86,455.52,285.46Zm-38.08,14.26a.63.63,0,0,0-.49.22L418,300A.67.67,0,0,0,417.44,299.72Zm9.5,0a.67.67,0,0,0-.67.67.68.68,0,0,0,.1.35l1.07.09a.64.64,0,0,0,.17-.44A.67.67,0,0,0,426.94,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,455.44,299.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.48,245.82c9,12.78,26,42.94,19.86,49.34-10,10.53-38.76,22-46.1,23.62-3.21.7-12.54-24.31-9.2-25.36,4.65-1.46,33-10.87,33-13,0-1.22-2.38-11.47-4.22-24.61C431.7,240.56,436.21,239.72,440.48,245.82Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,293s-10.5,1.4-17.33,2.64c-3.81.69-10.23,2.45-12.8,4.24-3.84,2.67-18.18,16.3-14.95,19.85,2.92,3.21,13.76-10.06,13.76-10.06s-12.12,12.43-7.89,15.65S382.17,312,382.17,312,370,325,374.89,327.63c3.7,2,13.83-12.54,13.83-12.54s-10.38,11.28-6.67,13.49c4.1,2.44,14.3-10.39,14.3-10.39,10.38,4,17,1.7,21.46-.51C418.89,317.14,406.9,293,406.9,293Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.49,305.14c-1.47,1.41-3,2.83-4.32,4.36s-2.64,3.12-3.84,4.77a35,35,0,0,0-4.05,6.88c2.24-4.19,7-9.76,8.32-11.3s2.61-3.13,4-4.66C379.59,305.15,379.53,305.11,379.49,305.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.12,309.9c-1.8,1.88-3.67,3.68-5.39,5.64s-4,4.77-5.61,6.83c-.12.16.06.4.18.25,1.66-2,4.15-4.76,5.84-6.74s3.29-4,5-5.94C385.2,309.91,385.15,309.87,385.12,309.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.69,313.12a58.2,58.2,0,0,0-7.59,9.26c-.11.16,0,.16.18,0,2.46-3.13,4.37-5.6,7.51-9.16C390.84,313.17,390.75,313.06,390.69,313.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.63,290l12.8,30.67s32.37-17.64,37.31-26.41c4.44-7.87-15.1-40.89-19.67-47.34s-9.23-7.65-9,3,4.19,30,4.18,30.26S411.63,290,411.63,290Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.86,250.15a.67.67,0,1,1-.67-.67A.67.67,0,0,1,441.86,250.15Zm-5.42-7.52a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,436.44,242.63Zm4.75,21.12a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,263.75Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,450.69,263.75Zm-14.25-6.84a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,256.91Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,256.91ZM441.19,278a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,278Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,450.69,278Zm-14.25-6.84a.68.68,0,0,0-.66.53v.05c0,.13,0,.26.06.39a.67.67,0,1,0,.6-1Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,271.18Zm10.16.6-.19-.4a.66.66,0,1,0,.2.47v-.06Zm-43.4,20.51h-.12l.51,1.21a.67.67,0,0,0-.39-1.22Zm9.49,0a.68.68,0,0,0,0,1.35.68.68,0,1,0,0-1.35Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,431.69,292.29Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,441.19,292.29Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,450.69,292.29Zm9.5,0a.68.68,0,1,0,.67.67A.67.67,0,0,0,460.19,292.29Zm-33.25-6.84a.67.67,0,1,0,.67.67A.67.67,0,0,0,426.94,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,285.45Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,455.44,285.45Zm-33.25,21.12a.67.67,0,0,0,0,1.34.67.67,0,1,0,0-1.34Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,431.69,306.57Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,441.19,306.57Zm-23.75-6.85a.67.67,0,1,0,.68.67A.67.67,0,0,0,417.44,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,426.94,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,436.44,299.72Zm9.5,0a.67.67,0,1,0,.67.67A.67.67,0,0,0,445.94,299.72Zm9.5,0a.67.67,0,0,0-.67.67.68.68,0,0,0,.43.63l.9-.75A.68.68,0,0,0,455.44,299.72Zm-38,14.27a.68.68,0,1,0,.68.68A.67.67,0,0,0,417.44,314Zm9.5,0a.68.68,0,1,0,.67.68A.67.67,0,0,0,426.94,314Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,302.15c-.93-2.32-4.76-11.52-5.92-13.69,0-.07-.13,0-.11.06.68,2.39,4.32,11.73,5.26,14.06,1.88,4.63,3.71,9.33,5.94,13.8.05.09.19.05.16-.05C427.83,311.51,425.87,306.83,424,302.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.47,268.33c-.66-4.05-1.24-8.11-1.83-12.18a.07.07,0,0,0-.14,0c.13,2.3.35,4.58.62,6.85-.34-1.18-.65-2.37-.94-3.56a.07.07,0,0,0-.14,0,23.71,23.71,0,0,0,1.21,4.61q.25,2.07.57,4.14c.31,2,1.89,10.87,2.13,11.87-3.42,1.08-6.45,2.45-9.8,3.72-1.64.63-9.21,3.21-10.84,3.87a45.21,45.21,0,0,0-5,2,6.08,6.08,0,0,0,.56,1.37c0,.09.2.09.17,0s-.32-.88-.34-1c.81-.2,4.06-1.48,4.9-1.8l4.92-1.87c3.32-1.28,16.16-5.87,16.16-5.92C437.63,279.59,435.81,270.39,435.47,268.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.32,297.33a23,23,0,0,1-2.92,3c-.53.45-1.07.9-1.64,1.3a13.65,13.65,0,0,1-1.78,1.12c1-1,2-1.88,3.09-2.8S458.18,298.15,459.32,297.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.77,242.61c-.27.94-5.18,6.9-9.53,6.45-1.42-.14-1-7.92-1-7.92l-.1-.59-1.36-8.15,9.79-5.55,1.41-.72s.23,2.25.48,5.06l0,.4c0,.16,0,.31.05.46,0,.42.09.84.12,1.27s.05.64.07,1,0,.67.06,1A52.57,52.57,0,0,1,434.77,242.61Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.5,231.19a16.57,16.57,0,0,1-10.32,9.36l-1.36-8.15,9.79-5.55,1.41-.72S434.25,228.38,434.5,231.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.1,216.3c-5.61,13.37,1.77,18.24,4.65,19.44,2.62,1.1,11.68,4.5,18.64-8.22s2.52-19.56-3.34-22.38S419.71,202.92,414.1,216.3Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417,214.78c.33.09.65.11,1,.17a1.61,1.61,0,0,0,1,0,.5.5,0,0,0,.23-.58,1.27,1.27,0,0,0-1.06-.74,1.89,1.89,0,0,0-1.34.18A.55.55,0,0,0,417,214.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.22,218.39c-.3-.16-.55-.36-.84-.55s-.59-.35-.74-.72a.52.52,0,0,1,.23-.59,1.27,1.27,0,0,1,1.28.19,1.87,1.87,0,0,1,.86,1.05A.55.55,0,0,1,426.22,218.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.78,220.86s.05.08,0,.11c-.41.9-.73,2,0,2.65a0,0,0,0,1,0,0C421.8,223.1,422.24,221.65,422.78,220.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,220.26c1.51.5.39,3.48-1,3S422.72,219.83,424,220.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.52,220.63c.19.27.34.66.64.81s.74,0,1.09-.24c0,0,.05,0,0,.05-.21.57-.65,1.08-1.29.93s-.8-.79-.73-1.41C424.29,220.65,424.44,220.53,424.52,220.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.71,218.74s-.09,0-.1,0c-.31.94-.82,2-1.77,2,0,0,0,.05,0,.06C416.9,221,417.57,219.68,417.71,218.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.24,217.47c-1.45-.66-2.66,2.28-1.32,2.89S418.46,218,417.24,217.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55,217.41c-.3.06-.65.25-.93.15s-.44-.53-.52-.92c0,0,0,0-.06,0-.25.56-.3,1.22.19,1.55s1,0,1.38-.53C416.68,217.57,416.67,217.38,416.55,217.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,228.49a1.43,1.43,0,0,1-1,.29,2.55,2.55,0,0,1-.93-.56,0,0,0,0,0-.06,0,1.34,1.34,0,0,0,1,.89,1,1,0,0,0,1-.59C420.14,228.51,420.07,228.47,420,228.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.48,223.67s-.73,1.3-1,1.94c0,.07.12.16.34.25,0,0,0,0,0,0a3.32,3.32,0,0,0,3.45,0,.07.07,0,0,0-.07-.13,4.92,4.92,0,0,1-3.12-.29c0-.19,1.31-2.18,1.21-2.23a5.91,5.91,0,0,0-1.6-.24c1.43-2.75,3.29-5.25,4.68-8a.1.1,0,0,0-.16-.11,50.17,50.17,0,0,0-5.4,8.42C415.65,223.64,417.18,223.68,417.48,223.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.42,213.39a58.35,58.35,0,0,0-2,5.7,24.93,24.93,0,0,0-1.08,5.89,11.4,11.4,0,0,0,5.19,10.15,10.51,10.51,0,0,1-5.4-7.1,11.31,11.31,0,0,1-.29-3.07,23.37,23.37,0,0,1,1.22-6A36.57,36.57,0,0,1,415.42,213.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.6,226.86c-2.68-.27-2-6.4-2-6.4s-10.68-4.42-9.56-13.68a15.69,15.69,0,0,1-9.64,6.61s2.66-9.83,11-10c0,0,10.57-1.32,14.29,7.68S438.4,227,436.6,226.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.18,206.1a10,10,0,0,0-.45,4.24,10.61,10.61,0,0,0,1.26,4.14,8.87,8.87,0,0,0,.58.92l.3.45.35.42c.24.27.47.55.72.8s.54.48.82.72l.41.35.45.3.89.59c.63.34,1.27.65,1.91.95-.57-.43-1.18-.79-1.74-1.21l-.81-.66-.41-.32-.37-.37c-.24-.25-.49-.5-.74-.74s-.43-.53-.65-.8l-.33-.4-.28-.43c-.17-.3-.39-.57-.53-.88a12.14,12.14,0,0,1-1.34-3.89,12,12,0,0,1-.18-2.08A11.41,11.41,0,0,1,425.18,206.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,231.81a3,3,0,0,1-.69-.05,2.13,2.13,0,0,1-.66-.19,2,2,0,0,1-.71-.51,2.23,2.23,0,0,1-.39-.57,2.75,2.75,0,0,1-.28-.94l1.95-3.45s4.4-3.34,6-1.63S437.56,231.69,435,231.81Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,226s0,.06,0,.06a6.22,6.22,0,0,0-4.23,2.71,1.35,1.35,0,0,1,2,.27s0,.1-.07.07a1.52,1.52,0,0,0-1.75,0,7.07,7.07,0,0,0-1.16,1c-.12.12-.36,0-.25-.19l0,0C434.17,227.87,436.69,225.51,439,226Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,231.16a.67.67,0,0,1-.92.26.67.67,0,0,1,.66-1.17A.67.67,0,0,1,435,231.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.61,230.62a.47.47,0,0,1-.64.18.47.47,0,1,1,.64-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27,241.16l1.58,6.72,9.09-6.81,1.84,2.91s-9.63,11.55-9.6,11l-1.78-5.85-4.34,3.22,1.76-9.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.66,247.58c.34-1.55.65-3.13,1.06-4.67,0-.06.11-.07.11,0,.08,1.57-1.26,7.51-1.47,9l0,0c.18-.14,4-2.81,4-2.75.44,1,1.75,5.22,1.83,5.6,1.52-1.84,7.9-9,9.63-10.72a.06.06,0,0,1,.09.07c-1.4,2-9.68,11.48-9.77,11.43a61.54,61.54,0,0,1-1.85-6.18,41.87,41.87,0,0,1-4.56,3.44C420.94,251.15,421.32,249.14,421.66,247.58Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.94,445.07c-1.93.6-58.07-.61-60.12-2-.79-.5,4-53.68,4-53.68l35.61.68-4,35.57s20.71,9.81,22.81,11.56S233.86,444.48,231.94,445.07Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.94,445.07c-1.92.6-58.07-.61-60.12-2-.25-.16-.32-5.55.57-12.59,10.18,1.71,46.52,7.29,49.35,5.62,2-1.15.23-3-1.39-4.19a97.2,97.2,0,0,1,9.86,5.29C232.29,439,233.86,444.48,231.94,445.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,417.13l-35-.49s6.92-83.72,6.64-85.33c-.37-2.06-25.17-99.31-25.17-99.31h33.36s26.31,90.64,27.25,99.37C217.06,345.47,208.4,417.13,208.4,417.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.59,408.75c2.07-.15,4.15-.13,6.22-.15s4.15,0,6.22,0q6.22.06,12.44.22l3.4.12c1.21.06,2.42.27,3.63.31.09,0,.09.15,0,.15-1,0-2,.16-3.05.19s-2.12,0-3.17,0c-2.07,0-4.15,0-6.22,0-4.14,0-8.29-.09-12.43-.26-2.34-.1-4.7-.13-7-.36A.11.11,0,1,1,176.59,408.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,239.86c3,10.57,5.72,21.23,8.39,31.88s5.34,21.33,8,32q2,8,4,16c1.29,5.19,2.79,10.41,3.11,15.77s-.37,11-.83,16.39-.92,10.91-1.4,16.37c-.95,10.92-1.87,21.85-3.06,32.74-.15,1.36-.29,2.73-.43,4.09a.1.1,0,0,1-.19,0c.73-10.93,1.48-21.85,2.35-32.76q.66-8.19,1.34-16.38c.45-5.44,1.08-10.91,1.25-16.37a58.29,58.29,0,0,0-2.16-16.13q-2-7.83-3.92-15.65-4-16-8-32c-3-11.94-5.92-23.91-8.54-35.93C162.14,239.82,162.24,239.79,162.25,239.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.91,232s10.65,41.72,18.09,71.09L187.19,232Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,445.2c-1.92.6-58.07-.61-60.12-2-.78-.5,2.15-53.71,2.15-53.71l35.13.68-1.7,35.6s20.72,9.81,22.81,11.56S192.68,444.61,190.76,445.2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.76,445.2c-1.92.6-58.07-.61-60.12-2-.24-.16-.19-5.42,0-12.59,10.18,1.7,47.08,7.29,49.91,5.62,2-1.15.23-3-1.39-4.19a99,99,0,0,1,9.87,5.29C191.12,439.08,192.68,444.61,190.76,445.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,232s-1,15.95-4.79,28.55c-.3,1-.63,2.06-1,3a59.05,59.05,0,0,0-9.67,4.82s-2.41,61-2.36,64.8c.15,14.18-3.47,83.22-3.47,83.22l-35.25-.34s3.66-78.07,3.67-83.27c0-8.34,7.4-100.82,7.4-100.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.13,254.92c.14-.93.28-1.86.43-2.79.26-1.7.6-3.39.9-5.08.68-3.85,1.38-7.71,2.24-11.52a.08.08,0,0,1,.16,0c-.15,1.53-.32,3.07-.54,4.6s-.37,3.08-.59,4.61c-.43,3-.85,6.08-1.37,9.11-.2,1.16-.92,3.25.76,3.61,1.32.29,2.3-1,2.69-2.11a27,27,0,0,0,.89-4.2c.28-1.53.52-3.07.73-4.61q.72-5,1.55-10.06c0-.09.16-.06.16,0-.11,3.45-.29,6.87-.74,10.29-.22,1.64-.46,3.27-.74,4.89a17.3,17.3,0,0,1-1.12,4.56,3.7,3.7,0,0,1-2.78,2.23h-.08a.14.14,0,0,1,0,.1c0,.54,0,1.09-.06,1.64s-.17,1.07-.27,1.6a9.65,9.65,0,0,1-.42,1.6,6.67,6.67,0,0,1-.29.74c-.12.24-.48,1.26-.62,1.49a.1.1,0,0,1-.18-.05s.2-1.46.22-1.62.1-.52.16-.78c.11-.51.25-1,.39-1.54s.25-1,.38-1.54.31-1,.43-1.58a.11.11,0,0,1,0-.05,2.42,2.42,0,0,1-2.34-1.47A4.27,4.27,0,0,1,176.13,254.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,269.62a27.48,27.48,0,0,1,3.31-2.19,32.15,32.15,0,0,1,3.78-1.95c2.55-1.11,5.18-1.87,7.81-2.74.08,0,.13.11,0,.14-2.54,1-5,2.36-7.45,3.56-1.21.6-2.44,1.16-3.67,1.7s-2.47,1.19-3.74,1.65C169.65,269.83,169.57,269.68,169.65,269.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.75,247.4a21.7,21.7,0,0,0,5.31-.72c.8-.2,1.59-.46,2.38-.72a6.15,6.15,0,0,0,2.14-1.07,9.4,9.4,0,0,0,2.29-4.14,38.28,38.28,0,0,0,1.4-5c0-.08.14-.05.14,0a19.6,19.6,0,0,1-.72,5.7,7,7,0,0,1-7.16,6.22,22.45,22.45,0,0,1-5.79-.08A.1.1,0,0,1,149.75,247.4Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.16,373.17q.9-16.71,1.9-33.42c1.28-22.16,2.53-44.33,3.92-66.49.79-12.5,1.6-25,2.58-37.49a.1.1,0,1,1,.2,0c-.88,22.29-2.24,44.57-3.53,66.84s-2.6,44.33-4,66.49c-.79,12.5-1.77,25-2.56,37.5a.08.08,0,0,1-.15,0C137.13,395.46,137.56,384.31,138.16,373.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,409.26c2.07-.14,4.15-.12,6.22-.15s4.15,0,6.22,0c4.15,0,8.29.1,12.44.22l3.4.12c1.21.06,2.42.26,3.63.31.09,0,.09.14,0,.15-1,0-2,.16-3,.19s-2.11,0-3.17,0c-2.07,0-4.15,0-6.22,0-4.14,0-8.29-.09-12.43-.26-2.34-.1-4.7-.13-7-.36A.11.11,0,0,1,133,409.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,145.47c9.52,10.73,14.43,36.93,7.77,52.61-7.93,18.69-25.94,27-39.61,21.24-12.42-5.24-16.92-18.64-11.4-27.83,5.34-8.88,14.28-11.53,16.6-19.64,1.11-3.88.36-10.55,1.2-16.48C157.12,144.59,173.62,137.12,181,145.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.88,193.56a20.49,20.49,0,0,1,3-5.47,25.43,25.43,0,0,1,4.18-4.36c1.57-1.27,3.1-2.59,4.6-4a26.43,26.43,0,0,0,4.1-4.69,19,19,0,0,0,1.57-2.81,13.7,13.7,0,0,0,.85-3.21,59.93,59.93,0,0,0,.41-6.53,28.66,28.66,0,0,1,.87-6.35,19.07,19.07,0,0,1,3-5.61,17.59,17.59,0,0,0-3.33,5.48,27.93,27.93,0,0,0-1.1,6.43c-.17,2.17-.18,4.35-.52,6.44a12.83,12.83,0,0,1-.83,3,17.55,17.55,0,0,1-1.52,2.66c-2.26,3.42-5.44,6-8.45,8.65a26.09,26.09,0,0,0-4.12,4.63A19.88,19.88,0,0,0,135.88,193.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,186c6.47,8.9,30.91,28.86,41.87,27.52,8.81-1.08,30.65-14.62,36.36-18.32,4.81-3.11-7.32-23.71-11.64-21.87-5.38,2.29-21.49,18.1-26.82,18-2.09,0-16.26-5.51-33.33-12.26C169.82,176.44,166.13,180.67,170,186Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.84,169c3.54-1.25,7.49-3,11.42-2.89s7.2,5.26,7.2,6.74S257,183.64,253,183.64s-1.55-7.11-1.7-7.93-.3-1.86-1-1.78-13.72,6.23-13.72,6.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09,169.58c.22,0,10.75-4.15,14.68-4.08s7.2,5.26,7.2,6.75S260.48,183,256.55,183s-1.55-7.12-1.7-7.93-.3-1.86-1-1.78-13.72,6.23-13.72,6.23Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.22,182.5a4.53,4.53,0,0,1-.65-2.32,7.85,7.85,0,0,1,.14-2.51,13.2,13.2,0,0,0,.47-2.16,4.33,4.33,0,0,0-.54-2.08c-.31-.55-.88-.36-1.38-.18a19.44,19.44,0,0,0-2.14,1c-.75.37-1.49.76-2.24,1.15a20.19,20.19,0,0,0-2.28,1.25.06.06,0,0,0,.05.11,21.07,21.07,0,0,0,2-.9l2.24-1c.71-.31,1.39-.66,2.1-1,.25-.11.75-.38,1-.31s.45.8.51,1a3.78,3.78,0,0,1-.13,2.13,11.18,11.18,0,0,0-.41,2.15,5.92,5.92,0,0,0,.16,2,8.76,8.76,0,0,0,.94,1.69C255.15,182.66,255.27,182.57,255.22,182.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.63,179.9S238.52,170,240.78,168c4.55-4,23.71-11.78,26.38-12.06s3.63,5.19-9.37,10.87c-6.85,3-8.07,6.92-7.94,9.1s2.2,6.23,5.86,6.13,6-5.44,9.39-6,1.15,5.56-1.23,9.12a22.32,22.32,0,0,1-9.84,7.68c-3.16,1.19-12.95,5.41-12.95,5.41Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,179.47c-1.38,1.06-2.94,2.44-4.75,2.51s-3.09-1.14-4-2.67a6.91,6.91,0,0,1-1-5.06,8.43,8.43,0,0,1,2.51-4.1,20.36,20.36,0,0,1,5-3.3c.08,0,0-.16-.07-.12-1.69.75-6.92,2.9-8,7.52a7.11,7.11,0,0,0,1,5.16c.81,1.45,2,2.86,3.77,3,2.16.18,4-1.58,5.57-2.89C260.43,179.46,260.32,179.41,260.25,179.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.82,176.79l7.23,32.38s-17.71,5.52-26.61,5.46-30.59-15.76-38.07-23.75-8.08-17,6.23-12,30.69,11.47,31.14,11.55S229.82,176.79,229.82,176.79Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.31,180a8.58,8.58,0,0,0-.28-1.58l-.09,0a7.41,7.41,0,0,0,0,1.63,8,8,0,0,0,.35,1.8A8,8,0,0,0,177.31,180Zm7.14,19.24a8.16,8.16,0,0,0-.35-1.81,8.11,8.11,0,0,0,0,1.84,8,8,0,0,0,.35,1.8A8,8,0,0,0,184.45,199.22Zm14.65-2.8a7.62,7.62,0,0,0-.35-1.81,8.1,8.1,0,0,0,0,1.84,7.45,7.45,0,0,0,.35,1.8A7.49,7.49,0,0,0,199.1,196.42Zm33.28-8.08c0-.06,0-.11,0-.17h0l-.34-1.52a7.71,7.71,0,0,0,0,1.73,7.45,7.45,0,0,0,.35,1.8A7.49,7.49,0,0,0,232.38,188.34Zm-43.66-4.71a10.41,10.41,0,0,0-.16-1.1h0l-.25-.09a10.1,10.1,0,0,0,0,1.23,7.43,7.43,0,0,0,.34,1.8A7.5,7.5,0,0,0,188.72,183.63Zm8.36,3.62a8.16,8.16,0,0,0-1.81.35,8.61,8.61,0,0,0,3.64-.31A8,8,0,0,0,197.08,187.25Zm1.65,19.29a8.16,8.16,0,0,0-1.81.35,8.61,8.61,0,0,0,3.64-.31A8,8,0,0,0,198.73,206.54Zm-28.07-21.07a8,8,0,0,0-1.52-1,8.78,8.78,0,0,0,2.79,2.35A8,8,0,0,0,170.66,185.47Zm19.93,7.67a8.12,8.12,0,0,0-1.52-1,8,8,0,0,0,1.27,1.33,7.74,7.74,0,0,0,1.53,1A7.68,7.68,0,0,0,190.59,193.14Zm34.62-10.5a7.53,7.53,0,0,0-1.52-1,7.94,7.94,0,0,0,1.27,1.32,7.66,7.66,0,0,0,1.52,1A7.58,7.58,0,0,0,225.21,182.64Zm-4.75,6.94a7.45,7.45,0,0,0-.35-1.8,9,9,0,0,0,.31,3.63A7.49,7.49,0,0,0,220.46,189.58Zm8.76,17.82a8.13,8.13,0,0,0-.34-1.81,8.61,8.61,0,0,0,.31,3.64A7.49,7.49,0,0,0,229.22,207.4Zm-14.3-1.18a8,8,0,0,0-.35-1.8,8,8,0,0,0,0,1.83,8.16,8.16,0,0,0,.35,1.81A8.11,8.11,0,0,0,214.92,206.22Zm-.21-10a8.16,8.16,0,0,0-1.81.35,8.11,8.11,0,0,0,1.84,0,8,8,0,0,0,1.8-.35A8,8,0,0,0,214.71,196.24Zm20.4,4.25-.32,0a7.45,7.45,0,0,0-1.8.35,8,8,0,0,0,1.83,0l.37,0Zm-27.62,10.4a8,8,0,0,0-1.52-1,8.78,8.78,0,0,0,2.79,2.35A7.58,7.58,0,0,0,207.49,210.89ZM206.09,192a7.62,7.62,0,0,0-1.52-1,8.36,8.36,0,0,0,1.27,1.32,7.74,7.74,0,0,0,1.53,1A7.68,7.68,0,0,0,206.09,192Zm16.4,9.32a7.92,7.92,0,0,0-1.52-1,8.36,8.36,0,0,0,1.27,1.32,8,8,0,0,0,1.52,1A7.63,7.63,0,0,0,222.49,201.29Zm-16.12.35a8,8,0,0,0-1,1.52,7.63,7.63,0,0,0,1.33-1.27,7.92,7.92,0,0,0,1-1.52A8.36,8.36,0,0,0,206.37,201.64Zm21.11-6.48a8,8,0,0,0-1,1.52,8.78,8.78,0,0,0,2.35-2.79A7.57,7.57,0,0,0,227.48,195.16ZM214,187.77h0l-.18.2a8,8,0,0,0-1,1.52,8,8,0,0,0,1.33-1.27,9.9,9.9,0,0,0,.76-1Zm6.13,23.14a8,8,0,0,0-1,1.52,8.78,8.78,0,0,0,2.35-2.79A8,8,0,0,0,220.08,210.91Zm-27.19-10a7.92,7.92,0,0,0-1,1.52,8.36,8.36,0,0,0,1.32-1.27,8,8,0,0,0,1-1.52A7.63,7.63,0,0,0,192.89,200.93Zm-11.21-12.7a7.53,7.53,0,0,0-1,1.52,8.36,8.36,0,0,0,1.32-1.27,8,8,0,0,0,1-1.52A7.58,7.58,0,0,0,181.68,188.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,195.25c-.51-2.35-2.43-11.73-2.68-14.08,0-.06.1-.07.12,0,.75,2.27,2.9,11.66,3.4,14,1,4.7,2.09,9.41,2.73,14.18a.08.08,0,0,1-.15,0C229.19,204.75,228.22,200,227.18,195.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.37,190.88c7.48,8,29.18,23.68,38.08,23.75a54.55,54.55,0,0,0,10.25-1.27l-53.31-33.59C166.49,182.37,168.52,186.77,172.37,190.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.67,212.77,190,236.61s-3.77,0-9.26,0l-2.64-4.83-3.7,4.84c-11.94,0-27.27-.08-32.84-.51,0,0,8.18-44.46,18.62-55.63,5.22-5.59,11.3-5.12,15.15-1.16,1,1,12.57,16.55,13.76,22.47C190.09,207.05,186.67,212.77,186.67,212.77Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52,236.15c5.57.44,20.9.52,32.84.51l3.7-4.84,2.64,4.84,9.27,0-3.3-23.84s3.42-5.72,2.38-10.94c-.65-3.24-4.43-9.38-7.87-14.44a.9.9,0,0,1-.14-.2c-2.79-4.07-5.31-7.39-5.75-7.83-3.7-3.81-9.46-4.39-14.53.53a0,0,0,0,0,0,0,.74.74,0,0,0-.13.12c-.16.16-.33.33-.48.5a28.29,28.29,0,0,0-4.1,6.17l-.18.34A117.1,117.1,0,0,0,149,205.28a2.17,2.17,0,0,0-.07.24C144.39,220.56,141.52,236.15,141.52,236.15Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,192a8.07,8.07,0,0,0-.35-1.8,8.11,8.11,0,0,0,0,1.84,7.54,7.54,0,0,0,.35,1.8A8.11,8.11,0,0,0,164.24,192Zm6.16,21.47a8.18,8.18,0,0,0-.35-1.8,8.61,8.61,0,0,0,.31,3.64A8.11,8.11,0,0,0,170.4,213.43Zm-9.34,17.32a7.54,7.54,0,0,0-.35-1.8,7.49,7.49,0,0,0,0,1.83,7.6,7.6,0,0,0,.34,1.81A7.57,7.57,0,0,0,161.06,230.75Zm23.39-31.53a8.16,8.16,0,0,0-.35-1.81,8.11,8.11,0,0,0,0,1.84,8,8,0,0,0,.35,1.8A8,8,0,0,0,184.45,199.22Zm-33.86,17.2a8.07,8.07,0,0,0-.35-1.8,8.61,8.61,0,0,0,.31,3.64A8.11,8.11,0,0,0,150.59,216.42Zm-6.19,14a8,8,0,0,0-.34-1.8,8.61,8.61,0,0,0,.31,3.64A7.56,7.56,0,0,0,144.4,230.4Zm28.86-36.07a7.54,7.54,0,0,0-1.8.35,8,8,0,0,0,1.83,0,8.16,8.16,0,0,0,1.81-.35A8.11,8.11,0,0,0,173.26,194.33Zm-21.59,40.76a8,8,0,0,0-1.8.35,8,8,0,0,0,1.83,0,8.16,8.16,0,0,0,1.81-.35A8.11,8.11,0,0,0,151.67,235.09Zm6-24.71a8.18,8.18,0,0,0-1.8.35,7.57,7.57,0,0,0,1.84,0,8.07,8.07,0,0,0,1.8-.35A8.11,8.11,0,0,0,157.68,210.38Zm28.2-1.36a8,8,0,0,0-1.8.35,7.49,7.49,0,0,0,1.83,0,8,8,0,0,0,1.8-.35A8,8,0,0,0,185.88,209ZM169,223.89a8.16,8.16,0,0,0-1.81.35,8.11,8.11,0,0,0,1.84,0,8,8,0,0,0,1.8-.35A8,8,0,0,0,169,223.89Zm16.66-.89a8,8,0,0,0-1.8.35,8.58,8.58,0,0,0,3.63-.31A8,8,0,0,0,185.69,223Zm-23.48-43.35a8.78,8.78,0,0,0-1.45.24,0,0,0,0,0,0,0,.74.74,0,0,0-.13.12,8.08,8.08,0,0,0,1.63,0,7,7,0,0,0,1.79-.35A8,8,0,0,0,162.21,179.65Zm8.45,5.82a8,8,0,0,0-1.52-1,8.78,8.78,0,0,0,2.79,2.35A8,8,0,0,0,170.66,185.47ZM165.29,204a7.92,7.92,0,0,0-1.52-1A8.36,8.36,0,0,0,165,204.3a8,8,0,0,0,1.52,1A8,8,0,0,0,165.29,204Zm-10-15.26-.2-.16c-.06.12-.12.24-.17.36l.12.1a8,8,0,0,0,1.52,1A8,8,0,0,0,155.31,188.74Zm-6.06,15.64a2.91,2.91,0,0,0-.12.39,6.42,6.42,0,0,0,1.27.82A7.76,7.76,0,0,0,149.25,204.38ZM171,234.45a8.46,8.46,0,0,0-1.52-1,8.65,8.65,0,0,0,2.79,2.36A8,8,0,0,0,171,234.45Zm15.59-1.74a8,8,0,0,0-1.52-1,8,8,0,0,0,1.27,1.33,7.92,7.92,0,0,0,1.52,1A7.94,7.94,0,0,0,186.57,232.71ZM180,216.29a8.46,8.46,0,0,0-1.52-1,7.63,7.63,0,0,0,1.27,1.33,8,8,0,0,0,1.52,1A8,8,0,0,0,180,216.29Zm-28.19,9.79a8,8,0,0,0-1.52-1,8,8,0,0,0,1.27,1.33,7.92,7.92,0,0,0,1.52,1A8.36,8.36,0,0,0,151.81,226.08Zm4.62-26a8.46,8.46,0,0,0-1,1.52,8.65,8.65,0,0,0,2.36-2.79A8,8,0,0,0,156.43,200.06Zm3.1,19.88a7.53,7.53,0,0,0-1,1.52,8.78,8.78,0,0,0,2.35-2.79A7.58,7.58,0,0,0,159.53,219.94Zm18.24,7.56a7.53,7.53,0,0,0-1,1.52,8.78,8.78,0,0,0,2.35-2.79A7.23,7.23,0,0,0,177.77,227.5Zm-2-23.45a8,8,0,0,0-1,1.53,7.63,7.63,0,0,0,1.32-1.28,7.26,7.26,0,0,0,1-1.52A7.58,7.58,0,0,0,175.79,204.05Zm5.93-15.86s0,0,0,0a7.53,7.53,0,0,0-1,1.52,8,8,0,0,0,1.29-1.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.4,225.47c-.42-2.18-.73-3.89-1.08-6.08s-.72-4.37-1-6.57l0-.14.09-.14a16.8,16.8,0,0,0,2.24-5.51,12.81,12.81,0,0,0,.28-3,10.4,10.4,0,0,0-.45-2.92,36,36,0,0,0-2.39-5.59c-.95-1.81-1.72-3.33-2.78-5.09-.17-.27-.06-.34.1-.12,1.05,1.44,2.21,3.43,3.11,5a30.7,30.7,0,0,1,2.69,5.6,10.1,10.1,0,0,1,.55,3.13,13.29,13.29,0,0,1-.27,3.15A16.31,16.31,0,0,1,187,213l.07-.28c.29,2.19.53,4.4.78,6.6.23,2,.49,4.11.66,6.1C188.52,225.64,188.53,226.27,188.4,225.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.16,192.12a9.56,9.56,0,0,1,1.06,2.06,10.06,10.06,0,0,1,.35,1.1,4.44,4.44,0,0,1,.17,1.15c-.34-.7-.65-1.38-.92-2.1A12.54,12.54,0,0,1,185.16,192.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.48,182.25c1.3,2.54,2.5,5.14,3.65,7.75s2.19,5.29,3.09,8a32.89,32.89,0,0,1,1.09,4.18,11.52,11.52,0,0,1,0,4.38,22.32,22.32,0,0,1-3.35,8l.05-.23c.28,2.73.55,5.47.77,8.21s.45,5.49.63,8.24c-.41-2.73-.78-5.45-1.12-8.18s-.66-5.47-1-8.2v-.12l.07-.11a24.53,24.53,0,0,0,2-3.73,19.53,19.53,0,0,0,1.28-4c.67-2.75-.15-5.53-.94-8.25s-1.81-5.39-2.87-8S173.62,184.86,172.48,182.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,194a.77.77,0,1,1-.87-.65A.77.77,0,0,1,175.3,194Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,201.36a.76.76,0,1,1-.86-.65A.76.76,0,0,1,177.87,201.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.08,209.65a.76.76,0,1,1-.86-.65A.75.75,0,0,1,177.08,209.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,217.78a.76.76,0,0,1-1.51.21.76.76,0,1,1,1.51-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.59,225.61a.76.76,0,1,1-.86-.65A.76.76,0,0,1,175.59,225.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,212.09a43.88,43.88,0,0,1,6.28.15c1,.11,2.06.27,3.09.46.51.09,1,.17,1.54.24A6.77,6.77,0,0,0,185,213a0,0,0,0,1,0,.08,11,11,0,0,1-1.53.18,10.67,10.67,0,0,1-1.49-.06c-1-.11-2.1-.27-3.15-.38-2.12-.24-4.24-.48-6.38-.56C172.39,212.26,172.39,212.1,172.49,212.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,214.65a46.31,46.31,0,0,1,5.1-1c.86-.11,1.72-.17,2.58-.21l1.24,0c.46,0,.91,0,1.37,0,.05,0,.06.07,0,.07-.43,0-.86.13-1.28.18l-1.29.14c-.86.1-1.71.21-2.57.3-1.72.19-3.43.39-5.14.63A.07.07,0,0,1,167.63,214.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.91,182.31C150,194.38,133,222.93,138.68,229.22c9.39,10.34,31.94,19.27,38.95,21,3.06.74,13.28-21.34,10.39-23.07-3.46-2.08-27.66-9.48-27.59-11.54,0-1.17,2.55-11,4.63-23.53C167.47,177.47,163.16,176.56,158.91,182.31Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,225.85s9.11-2.92,15.16-4.55c3.38-.91,9.31-2,12.09-1.49,4.17.7,21.15,6.28,19.89,10.43C223,234,209,227.34,209,227.34s14.7,5.46,12.5,9.73-17-5.34-17-5.34,15,5.94,12,10c-2.24,3-16.14-4.89-16.14-4.89s12.84,5.2,10.67,8.44c-2.41,3.58-15.69-3-15.69-3-6.92,7.31-13.16,8.25-17.72,7.88C176.54,250.09,177,225.85,177,225.85Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.06,225.13c1.75.58,3.53,1.15,5.22,1.88s3.36,1.53,5,2.42a32,32,0,0,1,6,4,68.27,68.27,0,0,0-11.16-6c-1.69-.73-3.34-1.54-5-2.28C204,225.17,204,225.12,204.06,225.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3,231.19a58.84,58.84,0,0,1,12.8,5.59c.15.09.06.15-.1.07-2.13-1-10.82-4.6-12.72-5.61C201.25,231.23,201.27,231.19,201.3,231.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,236a40.13,40.13,0,0,1,9.3,4.26c.15.09,0,.15-.15.07-3-1.41-5.14-2.26-9.18-4.21C197.9,236.06,197.93,236,198,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.93,223.42l-13,29.14s-25-15.68-29.55-24.22c-4.07-7.66,15.46-38.9,20-45s9-7.13,8.54,3.06-4.72,28.66-4.72,29S179.93,223.42,179.93,223.42Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.77,227.5a7.53,7.53,0,0,0-1,1.52,7.44,7.44,0,0,0,1.19-1.12l.49-1.11C178.19,227,178,227.26,177.77,227.5Zm-17.05,12.19a8,8,0,0,0-1,1.53,8.82,8.82,0,0,0,2.36-2.8A8,8,0,0,0,160.72,239.69Zm-18.17-19.45a8.46,8.46,0,0,0-1,1.52,8.65,8.65,0,0,0,2.36-2.79A8,8,0,0,0,142.55,220.24Zm17-.3a7.53,7.53,0,0,0-1,1.52,8.78,8.78,0,0,0,2.35-2.79A7.58,7.58,0,0,0,159.53,219.94Zm-3.1-19.88a8.46,8.46,0,0,0-1,1.52,8.65,8.65,0,0,0,2.36-2.79A8,8,0,0,0,156.43,200.06Zm-4.62,26a8,8,0,0,0-1.52-1,8,8,0,0,0,1.27,1.33,7.92,7.92,0,0,0,1.52,1A8.36,8.36,0,0,0,151.81,226.08Zm2.72,16.82a8,8,0,0,0-1.52-1,8.78,8.78,0,0,0,2.79,2.35A8,8,0,0,0,154.53,242.9ZM171,234.45a8.46,8.46,0,0,0-1.52-1,8.65,8.65,0,0,0,2.79,2.36A8,8,0,0,0,171,234.45Zm-21.86-30.18a7.66,7.66,0,0,0-1.52-1,7.58,7.58,0,0,0,1.27,1.32,7.33,7.33,0,0,0,1.53,1A7.62,7.62,0,0,0,149.12,204.27Zm6.19-15.53a10.82,10.82,0,0,0-1.09-.79,1.63,1.63,0,0,1-.11.17,11.76,11.76,0,0,0,.95.92,8,8,0,0,0,1.52,1A8,8,0,0,0,155.31,188.74Zm6.9-9.09a8.78,8.78,0,0,0-1.45.24,0,0,0,0,0,0,0,.74.74,0,0,0-.13.12,8.08,8.08,0,0,0,1.63,0,7,7,0,0,0,1.79-.35A8,8,0,0,0,162.21,179.65Zm.42,70.13.44.29h0a6,6,0,0,0,.9-.23A6.79,6.79,0,0,0,162.63,249.78Zm6.4-25.89a8.16,8.16,0,0,0-1.81.35,8.11,8.11,0,0,0,1.84,0,8,8,0,0,0,1.8-.35A8,8,0,0,0,169,223.89ZM136.83,226a2.54,2.54,0,0,0,0,.39,7.51,7.51,0,0,0,1.67-.34A7.89,7.89,0,0,0,136.83,226Zm6.68-15.41a8.16,8.16,0,0,0-1.81.35,8.11,8.11,0,0,0,1.84,0,8,8,0,0,0,1.8-.35A8,8,0,0,0,143.51,210.61Zm14.17-.23a8.18,8.18,0,0,0-1.8.35,7.57,7.57,0,0,0,1.84,0,8.07,8.07,0,0,0,1.8-.35A8.11,8.11,0,0,0,157.68,210.38Zm-6,24.71a8,8,0,0,0-1.8.35,8,8,0,0,0,1.83,0,8.16,8.16,0,0,0,1.81-.35A8.11,8.11,0,0,0,151.67,235.09Zm-7.27-4.69a8,8,0,0,0-.34-1.8,8.61,8.61,0,0,0,.31,3.64A7.56,7.56,0,0,0,144.4,230.4Zm6.19-14a8.07,8.07,0,0,0-.35-1.8,8.61,8.61,0,0,0,.31,3.64A8.11,8.11,0,0,0,150.59,216.42Zm18,27.57a8,8,0,0,0-.35-1.8,8.58,8.58,0,0,0,.31,3.63A8,8,0,0,0,168.62,244Zm-7.56-13.24a7.54,7.54,0,0,0-.35-1.8,7.49,7.49,0,0,0,0,1.83,7.6,7.6,0,0,0,.34,1.81A7.57,7.57,0,0,0,161.06,230.75ZM164.24,192a8.07,8.07,0,0,0-.35-1.8,8.11,8.11,0,0,0,0,1.84,7.54,7.54,0,0,0,.35,1.8A8.11,8.11,0,0,0,164.24,192Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,234.78c1-2.21,4.85-11,6-13,0-.06.12,0,.1.06-.7,2.28-4.42,11.17-5.38,13.37-1.91,4.41-3.78,8.87-6,13.12a.08.08,0,0,1-.15-.06C163.86,243.68,165.85,239.22,167.76,234.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,204.05c.73-3.88,1.39-7.77,2.05-11.65,0-.08.14-.06.13,0-.18,2.2-.44,4.38-.75,6.56.35-1.12.68-2.26,1-3.4,0-.08.14,0,.12,0a22.58,22.58,0,0,1-1.27,4.4c-.2,1.32-.41,2.64-.64,4-.35,1.93-2.07,10.4-2.33,11.35,3.26,1.12,6.14,2.5,9.33,3.8,1.56.64,3.12,1.29,4.66,2a40.68,40.68,0,0,1,4.75,2.05c.08,0-.2.46-.3.66s-.2.08-.17,0a2.19,2.19,0,0,0,.08-.28c-.77-.2-3.86-1.51-4.66-1.84l-4.68-1.91c-3.16-1.3-9.73-4-9.73-4.06C160.86,214.8,162.82,206,163.19,204.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,178.49c.21.92,4.53,6.94,8.73,6.79,1.37-.05,1.43-7.54,1.43-7.54l.13-.55,1.82-7.73-9-5.93-1.31-.79s-.36,2.14-.78,4.82l-.06.38c0,.15-.05.29-.07.44-.07.4-.14.8-.2,1.21s-.09.61-.12.94-.09.65-.13,1A52.47,52.47,0,0,0,165.26,178.49Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25,167.56a15.92,15.92,0,0,0,9.3,9.63l1.82-7.73-9-5.93-1.31-.79S166.67,164.88,166.25,167.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.84,155.16c4,13.35-3.58,17.24-6.46,18.09-2.61.77-11.61,3.08-16.94-9.79s-.38-18.93,5.51-21S184.86,141.81,188.84,155.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.27,153.42c-.33.05-.64,0-1,.06a1.6,1.6,0,0,1-1-.13.5.5,0,0,1-.16-.59,1.23,1.23,0,0,1,1.09-.59,1.76,1.76,0,0,1,1.26.31A.53.53,0,0,1,186.27,153.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,155.91c.3-.12.56-.29.85-.44a1.53,1.53,0,0,0,.79-.62.48.48,0,0,0-.16-.58,1.23,1.23,0,0,0-1.24,0,1.81,1.81,0,0,0-.93.92C176.16,155.65,176.65,156.07,177.05,155.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,158.62s-.06.07-.05.11c.3.89.5,2-.24,2.52,0,0,0,.07,0,.05C180.78,160.86,180.51,159.43,180.08,158.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,157.92c-1.49.32-.73,3.29.66,3S180.24,157.64,179,157.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.44,158.22c-.21.24-.39.6-.7.71s-.7-.11-1-.35c0,0,0,0,0,0,.14.57.51,1.1,1.14,1s.85-.67.84-1.28C178.66,158.26,178.53,158.13,178.44,158.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,157.12s.09,0,.1.06c.19.93.58,2,1.49,2.06a0,0,0,0,1,0,0C185.67,159.4,185.17,158,185.13,157.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.72,156c1.45-.48,2.3,2.46,1,2.91S184.5,156.36,185.72,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.39,156c.27.09.59.3.87.24s.47-.46.59-.82c0,0,0,0,.05,0,.18.55.17,1.19-.34,1.46s-1-.14-1.26-.66C186.24,156.11,186.27,155.93,186.39,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,166.19c.27.17.55.42.89.38a2.43,2.43,0,0,0,.95-.44s.07,0,.05,0a1.26,1.26,0,0,1-1.07.75,1,1,0,0,1-.9-.67C181.8,166.2,181.87,166.17,181.91,166.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05,163.74a3.86,3.86,0,0,1-1.08,1.63,1.72,1.72,0,0,1-1,.4c-.79.06-1-.6-1.09-1.21a4.16,4.16,0,0,1,0-1A5,5,0,0,0,185.05,163.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,165.37a1.72,1.72,0,0,1-1,.4c-.79.06-1-.6-1.09-1.21A1.79,1.79,0,0,1,184,165.37Z",
    style: {
      fill: "#ff97b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.85,161.85s.55,1.32.73,2c0,.06-.14.13-.35.2,0,0,0,0,0,0a3.16,3.16,0,0,1-3.28-.34.07.07,0,0,1,.07-.12,4.73,4.73,0,0,0,3,.05c0-.19-1-2.22-.93-2.26a6,6,0,0,1,1.55-.06c-1.08-2.78-2.6-5.36-3.63-8.14a.09.09,0,0,1,.15-.08,48.51,48.51,0,0,1,4.29,8.59C186.59,162,185.13,161.89,184.85,161.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.28,163.14c3.2-.66,2.09-5.69,2.09-5.69s3.56-1.11,2.57-7a9,9,0,0,0,7.57,2.82c1.07-.07-3-2-3-2s5,2.89,12.44-.21c.52-.22-2.4-8.14-9.08-9.63s-11.82,1.27-14.76,5.91c0,0-4,3-3.61,7.34S165,163.39,166.28,163.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.88,168.39a2.51,2.51,0,0,0,.66,0,2.1,2.1,0,0,0,.65-.11,1.91,1.91,0,0,0,.74-.42,2.49,2.49,0,0,0,.43-.5,2.84,2.84,0,0,0,.36-.87l-1.5-3.49s-3.86-3.65-5.57-2.19S164.44,168,166.88,168.39Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.69,162.45a0,0,0,0,0,0,.07,6,6,0,0,1,3.77,3,1.3,1.3,0,0,0-2,.05s0,.09.06.07a1.45,1.45,0,0,1,1.66.18,6.66,6.66,0,0,1,1,1.11c.1.12.34,0,.26-.16l0,0C168.07,164.72,165.91,162.21,163.69,162.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,167.78a.65.65,0,0,0,.85.34.65.65,0,0,0-.51-1.19A.65.65,0,0,0,167,167.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.46,167.09a.44.44,0,0,0,.59.24.46.46,0,1,0-.59-.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.46,178.22l-1.88,6.69-8.51-7.72-2.31,3.31S172,192.55,171.93,192l2-5.81,4.23,3.43L176.86,180Z",
    style: {
      fill: "#4169E1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.81,184.79c-.28-1.58-.51-3.18-.86-4.75,0,0-.11-.07-.11,0-.16,1.57.93,7.61,1.09,9.07l0,0c-.18-.15-3.9-3-3.93-2.94-.48.94-2,5.17-2.08,5.55-1.45-1.91-7.55-9.42-9.22-11.19a.05.05,0,1,0-.09.06c1.32,2,9.23,12,9.32,11.92a62.57,62.57,0,0,0,2.14-6.14,42.44,42.44,0,0,0,4.43,3.67C178.38,188.41,178.08,186.37,177.81,184.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.34,135.43a12,12,0,0,1-2-6.61c0-8.36,9.18-15.14,20.5-15.14s20.5,6.78,20.5,15.14S215.13,144,203.8,144a24.61,24.61,0,0,1-14.14-4.19l-7.06,1.79Z",
    style: {
      fill: "#fffefd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.34,135.43a11.71,11.71,0,0,1-.55-12.71,16.08,16.08,0,0,1,4.52-5,21.42,21.42,0,0,1,6-3.08,28,28,0,0,1,6.6-1.35,28.66,28.66,0,0,1,6.73.33,22.31,22.31,0,0,1,12,5.85,14.4,14.4,0,0,1,3.62,5.77,11.81,11.81,0,0,1,.06,6.84,14.27,14.27,0,0,1-3.53,5.83,19.83,19.83,0,0,1-5.53,3.91,26.25,26.25,0,0,1-13.14,2.4,24.41,24.41,0,0,1-12.58-4.3l.19,0-7.09,1.69-.25.06.11-.23Zm0,0-2.63,6.19-.14-.16,7-1.9.1,0,.09.06a24.19,24.19,0,0,0,12.36,4,27.37,27.37,0,0,0,6.52-.47,23.68,23.68,0,0,0,6.2-2,19.24,19.24,0,0,0,5.25-3.76,13.18,13.18,0,0,0,3.26-5.46,10.72,10.72,0,0,0-.09-6.27,13.19,13.19,0,0,0-3.34-5.4,21.43,21.43,0,0,0-11.5-5.66,27.28,27.28,0,0,0-12.94.83,18.57,18.57,0,0,0-10.35,7.58,11.8,11.8,0,0,0-1.74,6.24A12.26,12.26,0,0,0,185.34,135.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.18,128.82a2.13,2.13,0,1,0,2.12-2.12A2.12,2.12,0,0,0,211.18,128.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.68,128.82a2.13,2.13,0,1,0,2.12-2.12A2.12,2.12,0,0,0,201.68,128.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.18,128.82a2.13,2.13,0,1,0,2.12-2.12A2.12,2.12,0,0,0,192.18,128.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.59,200.28a12,12,0,0,0,2-6.61c0-8.36-9.19-15.14-20.51-15.14s-20.49,6.78-20.49,15.14,9.17,15.15,20.49,15.15a24.65,24.65,0,0,0,14.15-4.19l7.06,1.79Z",
    style: {
      fill: "#fffefd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.59,200.28a12.07,12.07,0,0,0,1.92-6.25,11.71,11.71,0,0,0-1.74-6.24,18.52,18.52,0,0,0-10.34-7.58,27.33,27.33,0,0,0-12.95-.83A21.46,21.46,0,0,0,549,185a13.41,13.41,0,0,0-3.34,5.4,10.8,10.8,0,0,0-.08,6.27,13.18,13.18,0,0,0,3.26,5.46,18.94,18.94,0,0,0,5.25,3.76,23.49,23.49,0,0,0,6.19,2,27.46,27.46,0,0,0,6.53.47,24.06,24.06,0,0,0,12.35-4l.09-.06.1,0,7,1.9-.14.16Zm0,0,2.86,6.09.1.23-.24-.06-7.09-1.69.19,0a24.44,24.44,0,0,1-12.58,4.3,26.29,26.29,0,0,1-13.15-2.4,20,20,0,0,1-5.53-3.91,14.14,14.14,0,0,1-3.52-5.83,11.72,11.72,0,0,1,.06-6.84,14.18,14.18,0,0,1,3.62-5.77,22.31,22.31,0,0,1,12-5.85,28.61,28.61,0,0,1,6.73-.33,28,28,0,0,1,6.59,1.35,21.48,21.48,0,0,1,6,3.08,16.08,16.08,0,0,1,4.52,4.95,11.68,11.68,0,0,1-.56,12.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.76,193.67a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,557.76,193.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.26,193.67a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,567.26,193.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.76,193.67a2.13,2.13,0,1,1-2.12-2.12A2.12,2.12,0,0,1,576.76,193.67Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizingProjects);
export default __webpack_public_path__ + "static/media/organizing-projects.e7c2d0f515540824b77103dfdc24975a.svg";
export { ForwardRef as ReactComponent };